var Or = Object.defineProperty;
var Pr = (e, t, r) => t in e ? Or(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Q = (e, t, r) => (Pr(e, typeof t != "symbol" ? t + "" : t, r), r);
import nt, { useRef as ee, useEffect as se, useState as Ct, useCallback as ue, useMemo as It, useContext as Re } from "react";
import { useNavigate as Ur } from "react-router-dom";
var re = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Oe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ar(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function s() {
      return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(s) {
    var i = Object.getOwnPropertyDescriptor(e, s);
    Object.defineProperty(r, s, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[s];
      }
    });
  }), r;
}
var Je = { exports: {} }, he = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ot;
function jr() {
  if (Ot)
    return he;
  Ot = 1;
  var e = nt, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(c, u, h) {
    var w, f = {}, b = null, y = null;
    h !== void 0 && (b = "" + h), u.key !== void 0 && (b = "" + u.key), u.ref !== void 0 && (y = u.ref);
    for (w in u)
      s.call(u, w) && !o.hasOwnProperty(w) && (f[w] = u[w]);
    if (c && c.defaultProps)
      for (w in u = c.defaultProps, u)
        f[w] === void 0 && (f[w] = u[w]);
    return { $$typeof: t, type: c, key: b, ref: y, props: f, _owner: i.current };
  }
  return he.Fragment = r, he.jsx = a, he.jsxs = a, he;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pt;
function Mr() {
  return Pt || (Pt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = nt, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), x = Symbol.iterator, m = "@@iterator";
    function k(n) {
      if (n === null || typeof n != "object")
        return null;
      var d = x && n[x] || n[m];
      return typeof d == "function" ? d : null;
    }
    var O = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function l(n) {
      {
        for (var d = arguments.length, v = new Array(d > 1 ? d - 1 : 0), E = 1; E < d; E++)
          v[E - 1] = arguments[E];
        p("error", n, v);
      }
    }
    function p(n, d, v) {
      {
        var E = O.ReactDebugCurrentFrame, P = E.getStackAddendum();
        P !== "" && (d += "%s", v = v.concat([P]));
        var A = v.map(function(I) {
          return String(I);
        });
        A.unshift("Warning: " + d), Function.prototype.apply.call(console[n], console, A);
      }
    }
    var g = !1, _ = !1, S = !1, R = !1, U = !1, j;
    j = Symbol.for("react.module.reference");
    function B(n) {
      return !!(typeof n == "string" || typeof n == "function" || n === s || n === o || U || n === i || n === h || n === w || R || n === y || g || _ || S || typeof n == "object" && n !== null && (n.$$typeof === b || n.$$typeof === f || n.$$typeof === a || n.$$typeof === c || n.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      n.$$typeof === j || n.getModuleId !== void 0));
    }
    function H(n, d, v) {
      var E = n.displayName;
      if (E)
        return E;
      var P = d.displayName || d.name || "";
      return P !== "" ? v + "(" + P + ")" : v;
    }
    function z(n) {
      return n.displayName || "Context";
    }
    function L(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && l("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case s:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case h:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case c:
            var d = n;
            return z(d) + ".Consumer";
          case a:
            var v = n;
            return z(v._context) + ".Provider";
          case u:
            return H(n, n.render, "ForwardRef");
          case f:
            var E = n.displayName || null;
            return E !== null ? E : L(n.type) || "Memo";
          case b: {
            var P = n, A = P._payload, I = P._init;
            try {
              return L(I(A));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, V = 0, ne, te, oe, ut, lt, dt, ht;
    function gt() {
    }
    gt.__reactDisabledLog = !0;
    function nr() {
      {
        if (V === 0) {
          ne = console.log, te = console.info, oe = console.warn, ut = console.error, lt = console.group, dt = console.groupCollapsed, ht = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: gt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        V++;
      }
    }
    function or() {
      {
        if (V--, V === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, n, {
              value: ne
            }),
            info: $({}, n, {
              value: te
            }),
            warn: $({}, n, {
              value: oe
            }),
            error: $({}, n, {
              value: ut
            }),
            group: $({}, n, {
              value: lt
            }),
            groupCollapsed: $({}, n, {
              value: dt
            }),
            groupEnd: $({}, n, {
              value: ht
            })
          });
        }
        V < 0 && l("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var je = O.ReactCurrentDispatcher, Me;
    function ve(n, d, v) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (P) {
            var E = P.stack.trim().match(/\n( *(at )?)/);
            Me = E && E[1] || "";
          }
        return `
` + Me + n;
      }
    }
    var qe = !1, we;
    {
      var ar = typeof WeakMap == "function" ? WeakMap : Map;
      we = new ar();
    }
    function ft(n, d) {
      if (!n || qe)
        return "";
      {
        var v = we.get(n);
        if (v !== void 0)
          return v;
      }
      var E;
      qe = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var A;
      A = je.current, je.current = null, nr();
      try {
        if (d) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (G) {
              E = G;
            }
            Reflect.construct(n, [], I);
          } else {
            try {
              I.call();
            } catch (G) {
              E = G;
            }
            n.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (G) {
            E = G;
          }
          n();
        }
      } catch (G) {
        if (G && E && typeof G.stack == "string") {
          for (var C = G.stack.split(`
`), N = E.stack.split(`
`), M = C.length - 1, q = N.length - 1; M >= 1 && q >= 0 && C[M] !== N[q]; )
            q--;
          for (; M >= 1 && q >= 0; M--, q--)
            if (C[M] !== N[q]) {
              if (M !== 1 || q !== 1)
                do
                  if (M--, q--, q < 0 || C[M] !== N[q]) {
                    var F = `
` + C[M].replace(" at new ", " at ");
                    return n.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", n.displayName)), typeof n == "function" && we.set(n, F), F;
                  }
                while (M >= 1 && q >= 0);
              break;
            }
        }
      } finally {
        qe = !1, je.current = A, or(), Error.prepareStackTrace = P;
      }
      var ce = n ? n.displayName || n.name : "", xt = ce ? ve(ce) : "";
      return typeof n == "function" && we.set(n, xt), xt;
    }
    function cr(n, d, v) {
      return ft(n, !1);
    }
    function ur(n) {
      var d = n.prototype;
      return !!(d && d.isReactComponent);
    }
    function me(n, d, v) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return ft(n, ur(n));
      if (typeof n == "string")
        return ve(n);
      switch (n) {
        case h:
          return ve("Suspense");
        case w:
          return ve("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case u:
            return cr(n.render);
          case f:
            return me(n.type, d, v);
          case b: {
            var E = n, P = E._payload, A = E._init;
            try {
              return me(A(P), d, v);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, pt = {}, _t = O.ReactDebugCurrentFrame;
    function Se(n) {
      if (n) {
        var d = n._owner, v = me(n.type, n._source, d ? d.type : null);
        _t.setExtraStackFrame(v);
      } else
        _t.setExtraStackFrame(null);
    }
    function lr(n, d, v, E, P) {
      {
        var A = Function.call.bind(ye);
        for (var I in n)
          if (A(n, I)) {
            var C = void 0;
            try {
              if (typeof n[I] != "function") {
                var N = Error((E || "React class") + ": " + v + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw N.name = "Invariant Violation", N;
              }
              C = n[I](d, I, E, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              C = M;
            }
            C && !(C instanceof Error) && (Se(P), l("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", v, I, typeof C), Se(null)), C instanceof Error && !(C.message in pt) && (pt[C.message] = !0, Se(P), l("Failed %s type: %s", v, C.message), Se(null));
          }
      }
    }
    var dr = Array.isArray;
    function Le(n) {
      return dr(n);
    }
    function hr(n) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, v = d && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return v;
      }
    }
    function gr(n) {
      try {
        return vt(n), !1;
      } catch {
        return !0;
      }
    }
    function vt(n) {
      return "" + n;
    }
    function wt(n) {
      if (gr(n))
        return l("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hr(n)), vt(n);
    }
    var de = O.ReactCurrentOwner, fr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, mt, yt, Ne;
    Ne = {};
    function pr(n) {
      if (ye.call(n, "ref")) {
        var d = Object.getOwnPropertyDescriptor(n, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return n.ref !== void 0;
    }
    function _r(n) {
      if (ye.call(n, "key")) {
        var d = Object.getOwnPropertyDescriptor(n, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return n.key !== void 0;
    }
    function vr(n, d) {
      if (typeof n.ref == "string" && de.current && d && de.current.stateNode !== d) {
        var v = L(de.current.type);
        Ne[v] || (l('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(de.current.type), n.ref), Ne[v] = !0);
      }
    }
    function wr(n, d) {
      {
        var v = function() {
          mt || (mt = !0, l("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        v.isReactWarning = !0, Object.defineProperty(n, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function mr(n, d) {
      {
        var v = function() {
          yt || (yt = !0, l("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        v.isReactWarning = !0, Object.defineProperty(n, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var yr = function(n, d, v, E, P, A, I) {
      var C = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: n,
        key: d,
        ref: v,
        props: I,
        // Record the component responsible for creating this element.
        _owner: A
      };
      return C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(C, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(C, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    };
    function Sr(n, d, v, E, P) {
      {
        var A, I = {}, C = null, N = null;
        v !== void 0 && (wt(v), C = "" + v), _r(d) && (wt(d.key), C = "" + d.key), pr(d) && (N = d.ref, vr(d, P));
        for (A in d)
          ye.call(d, A) && !fr.hasOwnProperty(A) && (I[A] = d[A]);
        if (n && n.defaultProps) {
          var M = n.defaultProps;
          for (A in M)
            I[A] === void 0 && (I[A] = M[A]);
        }
        if (C || N) {
          var q = typeof n == "function" ? n.displayName || n.name || "Unknown" : n;
          C && wr(I, q), N && mr(I, q);
        }
        return yr(n, C, N, P, E, de.current, I);
      }
    }
    var He = O.ReactCurrentOwner, St = O.ReactDebugCurrentFrame;
    function ae(n) {
      if (n) {
        var d = n._owner, v = me(n.type, n._source, d ? d.type : null);
        St.setExtraStackFrame(v);
      } else
        St.setExtraStackFrame(null);
    }
    var Fe;
    Fe = !1;
    function We(n) {
      return typeof n == "object" && n !== null && n.$$typeof === t;
    }
    function bt() {
      {
        if (He.current) {
          var n = L(He.current.type);
          if (n)
            return `

Check the render method of \`` + n + "`.";
        }
        return "";
      }
    }
    function br(n) {
      {
        if (n !== void 0) {
          var d = n.fileName.replace(/^.*[\\\/]/, ""), v = n.lineNumber;
          return `

Check your code at ` + d + ":" + v + ".";
        }
        return "";
      }
    }
    var kt = {};
    function kr(n) {
      {
        var d = bt();
        if (!d) {
          var v = typeof n == "string" ? n : n.displayName || n.name;
          v && (d = `

Check the top-level render call using <` + v + ">.");
        }
        return d;
      }
    }
    function Et(n, d) {
      {
        if (!n._store || n._store.validated || n.key != null)
          return;
        n._store.validated = !0;
        var v = kr(d);
        if (kt[v])
          return;
        kt[v] = !0;
        var E = "";
        n && n._owner && n._owner !== He.current && (E = " It was passed a child from " + L(n._owner.type) + "."), ae(n), l('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, E), ae(null);
      }
    }
    function Rt(n, d) {
      {
        if (typeof n != "object")
          return;
        if (Le(n))
          for (var v = 0; v < n.length; v++) {
            var E = n[v];
            We(E) && Et(E, d);
          }
        else if (We(n))
          n._store && (n._store.validated = !0);
        else if (n) {
          var P = k(n);
          if (typeof P == "function" && P !== n.entries)
            for (var A = P.call(n), I; !(I = A.next()).done; )
              We(I.value) && Et(I.value, d);
        }
      }
    }
    function Er(n) {
      {
        var d = n.type;
        if (d == null || typeof d == "string")
          return;
        var v;
        if (typeof d == "function")
          v = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          v = d.propTypes;
        else
          return;
        if (v) {
          var E = L(d);
          lr(v, n.props, "prop", E, n);
        } else if (d.PropTypes !== void 0 && !Fe) {
          Fe = !0;
          var P = L(d);
          l("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && l("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rr(n) {
      {
        for (var d = Object.keys(n.props), v = 0; v < d.length; v++) {
          var E = d[v];
          if (E !== "children" && E !== "key") {
            ae(n), l("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), ae(null);
            break;
          }
        }
        n.ref !== null && (ae(n), l("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Tt(n, d, v, E, P, A) {
      {
        var I = B(n);
        if (!I) {
          var C = "";
          (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && (C += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var N = br(P);
          N ? C += N : C += bt();
          var M;
          n === null ? M = "null" : Le(n) ? M = "array" : n !== void 0 && n.$$typeof === t ? (M = "<" + (L(n.type) || "Unknown") + " />", C = " Did you accidentally export a JSX literal instead of a component?") : M = typeof n, l("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, C);
        }
        var q = Sr(n, d, v, P, A);
        if (q == null)
          return q;
        if (I) {
          var F = d.children;
          if (F !== void 0)
            if (E)
              if (Le(F)) {
                for (var ce = 0; ce < F.length; ce++)
                  Rt(F[ce], n);
                Object.freeze && Object.freeze(F);
              } else
                l("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Rt(F, n);
        }
        return n === s ? Rr(q) : Er(q), q;
      }
    }
    function Tr(n, d, v) {
      return Tt(n, d, v, !0);
    }
    function xr(n, d, v) {
      return Tt(n, d, v, !1);
    }
    var Cr = xr, Ir = Tr;
    ge.Fragment = s, ge.jsx = Cr, ge.jsxs = Ir;
  }()), ge;
}
process.env.NODE_ENV === "production" ? Je.exports = jr() : Je.exports = Mr();
var pe = Je.exports;
function qr(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Dt = { exports: {} };
const Lr = {}, Nr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lr
}, Symbol.toStringTag, { value: "Module" })), Hr = /* @__PURE__ */ Ar(Nr);
(function(e, t) {
  (function(r, s) {
    e.exports = s();
  })(re, function() {
    var r = r || function(s, i) {
      var o;
      if (typeof window < "u" && window.crypto && (o = window.crypto), typeof self < "u" && self.crypto && (o = self.crypto), typeof globalThis < "u" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window < "u" && window.msCrypto && (o = window.msCrypto), !o && typeof re < "u" && re.crypto && (o = re.crypto), !o && typeof qr == "function")
        try {
          o = Hr;
        } catch {
        }
      var a = function() {
        if (o) {
          if (typeof o.getRandomValues == "function")
            try {
              return o.getRandomValues(new Uint32Array(1))[0];
            } catch {
            }
          if (typeof o.randomBytes == "function")
            try {
              return o.randomBytes(4).readInt32LE();
            } catch {
            }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      }, c = Object.create || function() {
        function l() {
        }
        return function(p) {
          var g;
          return l.prototype = p, g = new l(), l.prototype = null, g;
        };
      }(), u = {}, h = u.lib = {}, w = h.Base = function() {
        return {
          /**
           * Creates a new object that inherits from this object.
           *
           * @param {Object} overrides Properties to copy into the new object.
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         field: 'value',
           *
           *         method: function () {
           *         }
           *     });
           */
          extend: function(l) {
            var p = c(this);
            return l && p.mixIn(l), (!p.hasOwnProperty("init") || this.init === p.init) && (p.init = function() {
              p.$super.init.apply(this, arguments);
            }), p.init.prototype = p, p.$super = this, p;
          },
          /**
           * Extends this object and runs the init method.
           * Arguments to create() will be passed to init().
           *
           * @return {Object} The new object.
           *
           * @static
           *
           * @example
           *
           *     var instance = MyType.create();
           */
          create: function() {
            var l = this.extend();
            return l.init.apply(l, arguments), l;
          },
          /**
           * Initializes a newly created object.
           * Override this method to add some logic when your objects are created.
           *
           * @example
           *
           *     var MyType = CryptoJS.lib.Base.extend({
           *         init: function () {
           *             // ...
           *         }
           *     });
           */
          init: function() {
          },
          /**
           * Copies properties into this object.
           *
           * @param {Object} properties The properties to mix in.
           *
           * @example
           *
           *     MyType.mixIn({
           *         field: 'value'
           *     });
           */
          mixIn: function(l) {
            for (var p in l)
              l.hasOwnProperty(p) && (this[p] = l[p]);
            l.hasOwnProperty("toString") && (this.toString = l.toString);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = instance.clone();
           */
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }(), f = h.WordArray = w.extend({
        /**
         * Initializes a newly created word array.
         *
         * @param {Array} words (Optional) An array of 32-bit words.
         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.create();
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
         */
        init: function(l, p) {
          l = this.words = l || [], p != i ? this.sigBytes = p : this.sigBytes = l.length * 4;
        },
        /**
         * Converts this word array to a string.
         *
         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
         *
         * @return {string} The stringified word array.
         *
         * @example
         *
         *     var string = wordArray + '';
         *     var string = wordArray.toString();
         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
         */
        toString: function(l) {
          return (l || y).stringify(this);
        },
        /**
         * Concatenates a word array to this word array.
         *
         * @param {WordArray} wordArray The word array to append.
         *
         * @return {WordArray} This word array.
         *
         * @example
         *
         *     wordArray1.concat(wordArray2);
         */
        concat: function(l) {
          var p = this.words, g = l.words, _ = this.sigBytes, S = l.sigBytes;
          if (this.clamp(), _ % 4)
            for (var R = 0; R < S; R++) {
              var U = g[R >>> 2] >>> 24 - R % 4 * 8 & 255;
              p[_ + R >>> 2] |= U << 24 - (_ + R) % 4 * 8;
            }
          else
            for (var j = 0; j < S; j += 4)
              p[_ + j >>> 2] = g[j >>> 2];
          return this.sigBytes += S, this;
        },
        /**
         * Removes insignificant bits.
         *
         * @example
         *
         *     wordArray.clamp();
         */
        clamp: function() {
          var l = this.words, p = this.sigBytes;
          l[p >>> 2] &= 4294967295 << 32 - p % 4 * 8, l.length = s.ceil(p / 4);
        },
        /**
         * Creates a copy of this word array.
         *
         * @return {WordArray} The clone.
         *
         * @example
         *
         *     var clone = wordArray.clone();
         */
        clone: function() {
          var l = w.clone.call(this);
          return l.words = this.words.slice(0), l;
        },
        /**
         * Creates a word array filled with random bytes.
         *
         * @param {number} nBytes The number of random bytes to generate.
         *
         * @return {WordArray} The random word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.lib.WordArray.random(16);
         */
        random: function(l) {
          for (var p = [], g = 0; g < l; g += 4)
            p.push(a());
          return new f.init(p, l);
        }
      }), b = u.enc = {}, y = b.Hex = {
        /**
         * Converts a word array to a hex string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The hex string.
         *
         * @static
         *
         * @example
         *
         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
         */
        stringify: function(l) {
          for (var p = l.words, g = l.sigBytes, _ = [], S = 0; S < g; S++) {
            var R = p[S >>> 2] >>> 24 - S % 4 * 8 & 255;
            _.push((R >>> 4).toString(16)), _.push((R & 15).toString(16));
          }
          return _.join("");
        },
        /**
         * Converts a hex string to a word array.
         *
         * @param {string} hexStr The hex string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
         */
        parse: function(l) {
          for (var p = l.length, g = [], _ = 0; _ < p; _ += 2)
            g[_ >>> 3] |= parseInt(l.substr(_, 2), 16) << 24 - _ % 8 * 4;
          return new f.init(g, p / 2);
        }
      }, x = b.Latin1 = {
        /**
         * Converts a word array to a Latin1 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Latin1 string.
         *
         * @static
         *
         * @example
         *
         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
         */
        stringify: function(l) {
          for (var p = l.words, g = l.sigBytes, _ = [], S = 0; S < g; S++) {
            var R = p[S >>> 2] >>> 24 - S % 4 * 8 & 255;
            _.push(String.fromCharCode(R));
          }
          return _.join("");
        },
        /**
         * Converts a Latin1 string to a word array.
         *
         * @param {string} latin1Str The Latin1 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
         */
        parse: function(l) {
          for (var p = l.length, g = [], _ = 0; _ < p; _++)
            g[_ >>> 2] |= (l.charCodeAt(_) & 255) << 24 - _ % 4 * 8;
          return new f.init(g, p);
        }
      }, m = b.Utf8 = {
        /**
         * Converts a word array to a UTF-8 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The UTF-8 string.
         *
         * @static
         *
         * @example
         *
         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
         */
        stringify: function(l) {
          try {
            return decodeURIComponent(escape(x.stringify(l)));
          } catch {
            throw new Error("Malformed UTF-8 data");
          }
        },
        /**
         * Converts a UTF-8 string to a word array.
         *
         * @param {string} utf8Str The UTF-8 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
         */
        parse: function(l) {
          return x.parse(unescape(encodeURIComponent(l)));
        }
      }, k = h.BufferedBlockAlgorithm = w.extend({
        /**
         * Resets this block algorithm's data buffer to its initial state.
         *
         * @example
         *
         *     bufferedBlockAlgorithm.reset();
         */
        reset: function() {
          this._data = new f.init(), this._nDataBytes = 0;
        },
        /**
         * Adds new data to this block algorithm's buffer.
         *
         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
         *
         * @example
         *
         *     bufferedBlockAlgorithm._append('data');
         *     bufferedBlockAlgorithm._append(wordArray);
         */
        _append: function(l) {
          typeof l == "string" && (l = m.parse(l)), this._data.concat(l), this._nDataBytes += l.sigBytes;
        },
        /**
         * Processes available data blocks.
         *
         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
         *
         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
         *
         * @return {WordArray} The processed data.
         *
         * @example
         *
         *     var processedData = bufferedBlockAlgorithm._process();
         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
         */
        _process: function(l) {
          var p, g = this._data, _ = g.words, S = g.sigBytes, R = this.blockSize, U = R * 4, j = S / U;
          l ? j = s.ceil(j) : j = s.max((j | 0) - this._minBufferSize, 0);
          var B = j * R, H = s.min(B * 4, S);
          if (B) {
            for (var z = 0; z < B; z += R)
              this._doProcessBlock(_, z);
            p = _.splice(0, B), g.sigBytes -= H;
          }
          return new f.init(p, H);
        },
        /**
         * Creates a copy of this object.
         *
         * @return {Object} The clone.
         *
         * @example
         *
         *     var clone = bufferedBlockAlgorithm.clone();
         */
        clone: function() {
          var l = w.clone.call(this);
          return l._data = this._data.clone(), l;
        },
        _minBufferSize: 0
      });
      h.Hasher = k.extend({
        /**
         * Configuration options.
         */
        cfg: w.extend(),
        /**
         * Initializes a newly created hasher.
         *
         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
         *
         * @example
         *
         *     var hasher = CryptoJS.algo.SHA256.create();
         */
        init: function(l) {
          this.cfg = this.cfg.extend(l), this.reset();
        },
        /**
         * Resets this hasher to its initial state.
         *
         * @example
         *
         *     hasher.reset();
         */
        reset: function() {
          k.reset.call(this), this._doReset();
        },
        /**
         * Updates this hasher with a message.
         *
         * @param {WordArray|string} messageUpdate The message to append.
         *
         * @return {Hasher} This hasher.
         *
         * @example
         *
         *     hasher.update('message');
         *     hasher.update(wordArray);
         */
        update: function(l) {
          return this._append(l), this._process(), this;
        },
        /**
         * Finalizes the hash computation.
         * Note that the finalize operation is effectively a destructive, read-once operation.
         *
         * @param {WordArray|string} messageUpdate (Optional) A final message update.
         *
         * @return {WordArray} The hash.
         *
         * @example
         *
         *     var hash = hasher.finalize();
         *     var hash = hasher.finalize('message');
         *     var hash = hasher.finalize(wordArray);
         */
        finalize: function(l) {
          l && this._append(l);
          var p = this._doFinalize();
          return p;
        },
        blockSize: 16,
        /**
         * Creates a shortcut function to a hasher's object interface.
         *
         * @param {Hasher} hasher The hasher to create a helper for.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
         */
        _createHelper: function(l) {
          return function(p, g) {
            return new l.init(g).finalize(p);
          };
        },
        /**
         * Creates a shortcut function to the HMAC's object interface.
         *
         * @param {Hasher} hasher The hasher to use in this HMAC helper.
         *
         * @return {Function} The shortcut function.
         *
         * @static
         *
         * @example
         *
         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
         */
        _createHmacHelper: function(l) {
          return function(p, g) {
            return new O.HMAC.init(l, g).finalize(p);
          };
        }
      });
      var O = u.algo = {};
      return u;
    }(Math);
    return r;
  });
})(Dt);
var Pe = Dt.exports;
const Fr = /* @__PURE__ */ Oe(Pe);
var Bt = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(Pe);
  })(re, function(r) {
    return function(s) {
      var i = r, o = i.lib, a = o.WordArray, c = o.Hasher, u = i.algo, h = [], w = [];
      (function() {
        function y(O) {
          for (var l = s.sqrt(O), p = 2; p <= l; p++)
            if (!(O % p))
              return !1;
          return !0;
        }
        function x(O) {
          return (O - (O | 0)) * 4294967296 | 0;
        }
        for (var m = 2, k = 0; k < 64; )
          y(m) && (k < 8 && (h[k] = x(s.pow(m, 1 / 2))), w[k] = x(s.pow(m, 1 / 3)), k++), m++;
      })();
      var f = [], b = u.SHA256 = c.extend({
        _doReset: function() {
          this._hash = new a.init(h.slice(0));
        },
        _doProcessBlock: function(y, x) {
          for (var m = this._hash.words, k = m[0], O = m[1], l = m[2], p = m[3], g = m[4], _ = m[5], S = m[6], R = m[7], U = 0; U < 64; U++) {
            if (U < 16)
              f[U] = y[x + U] | 0;
            else {
              var j = f[U - 15], B = (j << 25 | j >>> 7) ^ (j << 14 | j >>> 18) ^ j >>> 3, H = f[U - 2], z = (H << 15 | H >>> 17) ^ (H << 13 | H >>> 19) ^ H >>> 10;
              f[U] = B + f[U - 7] + z + f[U - 16];
            }
            var L = g & _ ^ ~g & S, $ = k & O ^ k & l ^ O & l, V = (k << 30 | k >>> 2) ^ (k << 19 | k >>> 13) ^ (k << 10 | k >>> 22), ne = (g << 26 | g >>> 6) ^ (g << 21 | g >>> 11) ^ (g << 7 | g >>> 25), te = R + ne + L + w[U] + f[U], oe = V + $;
            R = S, S = _, _ = g, g = p + te | 0, p = l, l = O, O = k, k = te + oe | 0;
          }
          m[0] = m[0] + k | 0, m[1] = m[1] + O | 0, m[2] = m[2] + l | 0, m[3] = m[3] + p | 0, m[4] = m[4] + g | 0, m[5] = m[5] + _ | 0, m[6] = m[6] + S | 0, m[7] = m[7] + R | 0;
        },
        _doFinalize: function() {
          var y = this._data, x = y.words, m = this._nDataBytes * 8, k = y.sigBytes * 8;
          return x[k >>> 5] |= 128 << 24 - k % 32, x[(k + 64 >>> 9 << 4) + 14] = s.floor(m / 4294967296), x[(k + 64 >>> 9 << 4) + 15] = m, y.sigBytes = x.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var y = c.clone.call(this);
          return y._hash = this._hash.clone(), y;
        }
      });
      i.SHA256 = c._createHelper(b), i.HmacSHA256 = c._createHmacHelper(b);
    }(Math), r.SHA256;
  });
})(Bt);
var Wr = Bt.exports;
const Dr = /* @__PURE__ */ Oe(Wr);
var $t = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(Pe);
  })(re, function(r) {
    return function() {
      var s = r, i = s.lib, o = i.WordArray, a = s.enc;
      a.Base64 = {
        /**
         * Converts a word array to a Base64 string.
         *
         * @param {WordArray} wordArray The word array.
         *
         * @return {string} The Base64 string.
         *
         * @static
         *
         * @example
         *
         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
         */
        stringify: function(u) {
          var h = u.words, w = u.sigBytes, f = this._map;
          u.clamp();
          for (var b = [], y = 0; y < w; y += 3)
            for (var x = h[y >>> 2] >>> 24 - y % 4 * 8 & 255, m = h[y + 1 >>> 2] >>> 24 - (y + 1) % 4 * 8 & 255, k = h[y + 2 >>> 2] >>> 24 - (y + 2) % 4 * 8 & 255, O = x << 16 | m << 8 | k, l = 0; l < 4 && y + l * 0.75 < w; l++)
              b.push(f.charAt(O >>> 6 * (3 - l) & 63));
          var p = f.charAt(64);
          if (p)
            for (; b.length % 4; )
              b.push(p);
          return b.join("");
        },
        /**
         * Converts a Base64 string to a word array.
         *
         * @param {string} base64Str The Base64 string.
         *
         * @return {WordArray} The word array.
         *
         * @static
         *
         * @example
         *
         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
         */
        parse: function(u) {
          var h = u.length, w = this._map, f = this._reverseMap;
          if (!f) {
            f = this._reverseMap = [];
            for (var b = 0; b < w.length; b++)
              f[w.charCodeAt(b)] = b;
          }
          var y = w.charAt(64);
          if (y) {
            var x = u.indexOf(y);
            x !== -1 && (h = x);
          }
          return c(u, h, f);
        },
        _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
      };
      function c(u, h, w) {
        for (var f = [], b = 0, y = 0; y < h; y++)
          if (y % 4) {
            var x = w[u.charCodeAt(y - 1)] << y % 4 * 2, m = w[u.charCodeAt(y)] >>> 6 - y % 4 * 2, k = x | m;
            f[b >>> 2] |= k << 24 - b % 4 * 8, b++;
          }
        return o.create(f, b);
      }
    }(), r.enc.Base64;
  });
})($t);
var Br = $t.exports;
const Ut = /* @__PURE__ */ Oe(Br);
var zt = { exports: {} };
(function(e, t) {
  (function(r, s) {
    e.exports = s(Pe);
  })(re, function(r) {
    return r.enc.Utf8;
  });
})(zt);
var $r = zt.exports;
const zr = /* @__PURE__ */ Oe($r);
function Ke(e) {
  this.message = e;
}
Ke.prototype = new Error(), Ke.prototype.name = "InvalidCharacterError";
var At = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new Ke("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, s, i = 0, o = 0, a = ""; s = t.charAt(o++); ~s && (r = i % 4 ? 64 * r + s : s, i++ % 4) ? a += String.fromCharCode(255 & r >> (-2 * i & 6)) : 0)
    s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s);
  return a;
};
function Jr(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(r) {
      return decodeURIComponent(At(r).replace(/(.)/g, function(s, i) {
        var o = i.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      }));
    }(t);
  } catch {
    return At(t);
  }
}
function Te(e) {
  this.message = e;
}
function Kr(e, t) {
  if (typeof e != "string")
    throw new Te("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(Jr(e.split(".")[r]));
  } catch (s) {
    throw new Te("Invalid token specified: " + s.message);
  }
}
Te.prototype = new Error(), Te.prototype.name = "InvalidTokenError";
var Yr = {
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
}, J, K, xe = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.ERROR = 1] = "ERROR", e[e.WARN = 2] = "WARN", e[e.INFO = 3] = "INFO", e[e.DEBUG = 4] = "DEBUG", e))(xe || {});
((e) => {
  function t() {
    J = 3, K = Yr;
  }
  e.reset = t;
  function r(i) {
    if (!(0 <= i && i <= 4))
      throw new Error("Invalid log level");
    J = i;
  }
  e.setLevel = r;
  function s(i) {
    K = i;
  }
  e.setLogger = s;
})(xe || (xe = {}));
var T = class {
  constructor(e) {
    this._name = e;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  debug(...e) {
    J >= 4 && K.debug(T._format(this._name, this._method), ...e);
  }
  info(...e) {
    J >= 3 && K.info(T._format(this._name, this._method), ...e);
  }
  warn(...e) {
    J >= 2 && K.warn(T._format(this._name, this._method), ...e);
  }
  error(...e) {
    J >= 1 && K.error(T._format(this._name, this._method), ...e);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
  throw(e) {
    throw this.error(e), e;
  }
  create(e) {
    const t = Object.create(this);
    return t._method = e, t.debug("begin"), t;
  }
  static createStatic(e, t) {
    const r = new T(`${e}.${t}`);
    return r.debug("begin"), r;
  }
  static _format(e, t) {
    const r = `[${e}]`;
    return t ? `${r} ${t}:` : r;
  }
  /* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
  // helpers for static class methods
  static debug(e, ...t) {
    J >= 4 && K.debug(T._format(e), ...t);
  }
  static info(e, ...t) {
    J >= 3 && K.info(T._format(e), ...t);
  }
  static warn(e, ...t) {
    J >= 2 && K.warn(T._format(e), ...t);
  }
  static error(e, ...t) {
    J >= 1 && K.error(T._format(e), ...t);
  }
  /* eslint-enable @typescript-eslint/no-unsafe-enum-comparison */
};
xe.reset();
var Vr = "10000000-1000-4000-8000-100000000000", Y = class {
  static _randomWord() {
    return Fr.lib.WordArray.random(1).words[0];
  }
  /**
   * Generates RFC4122 version 4 guid
   */
  static generateUUIDv4() {
    return Vr.replace(
      /[018]/g,
      (t) => (+t ^ Y._randomWord() & 15 >> +t / 4).toString(16)
    ).replace(/-/g, "");
  }
  /**
   * PKCE: Generate a code verifier
   */
  static generateCodeVerifier() {
    return Y.generateUUIDv4() + Y.generateUUIDv4() + Y.generateUUIDv4();
  }
  /**
   * PKCE: Generate a code challenge
   */
  static generateCodeChallenge(e) {
    try {
      const t = Dr(e);
      return Ut.stringify(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (t) {
      throw T.error("CryptoUtils.generateCodeChallenge", t), t;
    }
  }
  /**
   * Generates a base64-encoded string for a basic auth header
   */
  static generateBasicAuth(e, t) {
    const r = zr.parse([e, t].join(":"));
    return Ut.stringify(r);
  }
}, Z = class {
  constructor(e) {
    this._name = e, this._logger = new T(`Event('${this._name}')`), this._callbacks = [];
  }
  addHandler(e) {
    return this._callbacks.push(e), () => this.removeHandler(e);
  }
  removeHandler(e) {
    const t = this._callbacks.lastIndexOf(e);
    t >= 0 && this._callbacks.splice(t, 1);
  }
  raise(...e) {
    this._logger.debug("raise:", ...e);
    for (const t of this._callbacks)
      t(...e);
  }
}, Ye = class {
  // IMPORTANT: doesn't validate the token
  static decode(e) {
    try {
      return Kr(e);
    } catch (t) {
      throw T.error("JwtUtils.decode", t), t;
    }
  }
}, jt = class {
  /**
   * Populates a map of window features with a placement centered in front of
   * the current window. If no explicit width is given, a default value is
   * binned into [800, 720, 600, 480, 360] based on the current window's width.
   */
  static center({ ...e }) {
    var t, r, s;
    return e.width == null && (e.width = (t = [800, 720, 600, 480].find((i) => i <= window.outerWidth / 1.618)) != null ? t : 360), (r = e.left) != null || (e.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - e.width) / 2))), e.height != null && ((s = e.top) != null || (e.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - e.height) / 2)))), e;
  }
  static serialize(e) {
    return Object.entries(e).filter(([, t]) => t != null).map(([t, r]) => `${t}=${typeof r != "boolean" ? r : r ? "yes" : "no"}`).join(",");
  }
}, D = class extends Z {
  constructor() {
    super(...arguments), this._logger = new T(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
      const e = this._expiration - D.getEpochTime();
      this._logger.debug("timer completes in", e), this._expiration <= D.getEpochTime() && (this.cancel(), super.raise());
    };
  }
  // get the time
  static getEpochTime() {
    return Math.floor(Date.now() / 1e3);
  }
  init(e) {
    const t = this._logger.create("init");
    e = Math.max(Math.floor(e), 1);
    const r = D.getEpochTime() + e;
    if (this.expiration === r && this._timerHandle) {
      t.debug("skipping since already initialized for expiration at", this.expiration);
      return;
    }
    this.cancel(), t.debug("using duration", e), this._expiration = r;
    const s = Math.min(e, 5);
    this._timerHandle = setInterval(this._callback, s * 1e3);
  }
  get expiration() {
    return this._expiration;
  }
  cancel() {
    this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
  }
}, Ve = class {
  static readParams(e, t = "query") {
    if (!e)
      throw new TypeError("Invalid URL");
    const s = new URL(e, "http://127.0.0.1")[t === "fragment" ? "hash" : "search"];
    return new URLSearchParams(s.slice(1));
  }
}, Ge = ";", ie = class extends Error {
  constructor(e, t) {
    var r, s, i;
    if (super(e.error_description || e.error || ""), this.form = t, this.name = "ErrorResponse", !e.error)
      throw T.error("ErrorResponse", "No error passed"), new Error("No error passed");
    this.error = e.error, this.error_description = (r = e.error_description) != null ? r : null, this.error_uri = (s = e.error_uri) != null ? s : null, this.state = e.userState, this.session_state = (i = e.session_state) != null ? i : null, this.url_state = e.url_state;
  }
}, ot = class extends Error {
  constructor(e) {
    super(e), this.name = "ErrorTimeout";
  }
}, Gr = class {
  constructor(e) {
    this._logger = new T("AccessTokenEvents"), this._expiringTimer = new D("Access token expiring"), this._expiredTimer = new D("Access token expired"), this._expiringNotificationTimeInSeconds = e.expiringNotificationTimeInSeconds;
  }
  load(e) {
    const t = this._logger.create("load");
    if (e.access_token && e.expires_in !== void 0) {
      const r = e.expires_in;
      if (t.debug("access token present, remaining duration:", r), r > 0) {
        let i = r - this._expiringNotificationTimeInSeconds;
        i <= 0 && (i = 1), t.debug("registering expiring timer, raising in", i, "seconds"), this._expiringTimer.init(i);
      } else
        t.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
      const s = r + 1;
      t.debug("registering expired timer, raising in", s, "seconds"), this._expiredTimer.init(s);
    } else
      this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  unload() {
    this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
  }
  /**
   * Add callback: Raised prior to the access token expiring.
   */
  addAccessTokenExpiring(e) {
    return this._expiringTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised prior to the access token expiring.
   */
  removeAccessTokenExpiring(e) {
    this._expiringTimer.removeHandler(e);
  }
  /**
   * Add callback: Raised after the access token has expired.
   */
  addAccessTokenExpired(e) {
    return this._expiredTimer.addHandler(e);
  }
  /**
   * Remove callback: Raised after the access token has expired.
   */
  removeAccessTokenExpired(e) {
    this._expiredTimer.removeHandler(e);
  }
}, Xr = class {
  constructor(e, t, r, s, i) {
    this._callback = e, this._client_id = t, this._intervalInSeconds = s, this._stopOnError = i, this._logger = new T("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (a) => {
      a.origin === this._frame_origin && a.source === this._frame.contentWindow && (a.data === "error" ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : a.data === "changed" ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(a.data + " message from check session op iframe"));
    };
    const o = new URL(r);
    this._frame_origin = o.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = o.href;
  }
  load() {
    return new Promise((e) => {
      this._frame.onload = () => {
        e();
      }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, !1);
    });
  }
  start(e) {
    if (this._session_state === e)
      return;
    this._logger.create("start"), this.stop(), this._session_state = e;
    const t = () => {
      !this._frame.contentWindow || !this._session_state || this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
    };
    t(), this._timer = setInterval(t, this._intervalInSeconds * 1e3);
  }
  stop() {
    this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
  }
}, Jt = class {
  constructor() {
    this._logger = new T("InMemoryWebStorage"), this._data = {};
  }
  clear() {
    this._logger.create("clear"), this._data = {};
  }
  getItem(e) {
    return this._logger.create(`getItem('${e}')`), this._data[e];
  }
  setItem(e, t) {
    this._logger.create(`setItem('${e}')`), this._data[e] = t;
  }
  removeItem(e) {
    this._logger.create(`removeItem('${e}')`), delete this._data[e];
  }
  get length() {
    return Object.getOwnPropertyNames(this._data).length;
  }
  key(e) {
    return Object.getOwnPropertyNames(this._data)[e];
  }
}, at = class {
  constructor(e = [], t = null, r = {}) {
    this._jwtHandler = t, this._extraHeaders = r, this._logger = new T("JsonService"), this._contentTypes = [], this._contentTypes.push(...e, "application/json"), t && this._contentTypes.push("application/jwt");
  }
  async fetchWithTimeout(e, t = {}) {
    const { timeoutInSeconds: r, ...s } = t;
    if (!r)
      return await fetch(e, s);
    const i = new AbortController(), o = setTimeout(() => i.abort(), r * 1e3);
    try {
      return await fetch(e, {
        ...t,
        signal: i.signal
      });
    } catch (a) {
      throw a instanceof DOMException && a.name === "AbortError" ? new ot("Network timed out") : a;
    } finally {
      clearTimeout(o);
    }
  }
  async getJson(e, {
    token: t,
    credentials: r
  } = {}) {
    const s = this._logger.create("getJson"), i = {
      Accept: this._contentTypes.join(", ")
    };
    t && (s.debug("token passed, setting Authorization header"), i.Authorization = "Bearer " + t), this.appendExtraHeaders(i);
    let o;
    try {
      s.debug("url:", e), o = await this.fetchWithTimeout(e, { method: "GET", headers: i, credentials: r });
    } catch (u) {
      throw s.error("Network Error"), u;
    }
    s.debug("HTTP response received, status", o.status);
    const a = o.headers.get("Content-Type");
    if (a && !this._contentTypes.find((u) => a.startsWith(u)) && s.throw(new Error(`Invalid response Content-Type: ${a ?? "undefined"}, from URL: ${e}`)), o.ok && this._jwtHandler && (a != null && a.startsWith("application/jwt")))
      return await this._jwtHandler(await o.text());
    let c;
    try {
      c = await o.json();
    } catch (u) {
      throw s.error("Error parsing JSON response", u), o.ok ? u : new Error(`${o.statusText} (${o.status})`);
    }
    if (!o.ok)
      throw s.error("Error from server:", c), c.error ? new ie(c) : new Error(`${o.statusText} (${o.status}): ${JSON.stringify(c)}`);
    return c;
  }
  async postForm(e, {
    body: t,
    basicAuth: r,
    timeoutInSeconds: s,
    initCredentials: i
  }) {
    const o = this._logger.create("postForm"), a = {
      Accept: this._contentTypes.join(", "),
      "Content-Type": "application/x-www-form-urlencoded"
    };
    r !== void 0 && (a.Authorization = "Basic " + r), this.appendExtraHeaders(a);
    let c;
    try {
      o.debug("url:", e), c = await this.fetchWithTimeout(e, { method: "POST", headers: a, body: t, timeoutInSeconds: s, credentials: i });
    } catch (f) {
      throw o.error("Network error"), f;
    }
    o.debug("HTTP response received, status", c.status);
    const u = c.headers.get("Content-Type");
    if (u && !this._contentTypes.find((f) => u.startsWith(f)))
      throw new Error(`Invalid response Content-Type: ${u ?? "undefined"}, from URL: ${e}`);
    const h = await c.text();
    let w = {};
    if (h)
      try {
        w = JSON.parse(h);
      } catch (f) {
        throw o.error("Error parsing JSON response", f), c.ok ? f : new Error(`${c.statusText} (${c.status})`);
      }
    if (!c.ok)
      throw o.error("Error from server:", w), w.error ? new ie(w, t) : new Error(`${c.statusText} (${c.status}): ${JSON.stringify(w)}`);
    return w;
  }
  appendExtraHeaders(e) {
    const t = this._logger.create("appendExtraHeaders"), r = Object.keys(this._extraHeaders), s = [
      "authorization",
      "accept",
      "content-type"
    ];
    r.length !== 0 && r.forEach((i) => {
      if (s.includes(i.toLocaleLowerCase())) {
        t.warn("Protected header could not be overridden", i, s);
        return;
      }
      const o = typeof this._extraHeaders[i] == "function" ? this._extraHeaders[i]() : this._extraHeaders[i];
      o && o !== "" && (e[i] = o);
    });
  }
}, Qr = class {
  constructor(e) {
    this._settings = e, this._logger = new T("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new at(
      ["application/jwk-set+json"],
      null,
      this._settings.extraHeaders
    ), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
  }
  resetSigningKeys() {
    this._signingKeys = null;
  }
  async getMetadata() {
    const e = this._logger.create("getMetadata");
    if (this._metadata)
      return e.debug("using cached values"), this._metadata;
    if (!this._metadataUrl)
      throw e.throw(new Error("No authority or metadataUrl configured on settings")), null;
    e.debug("getting metadata from", this._metadataUrl);
    const t = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials });
    return e.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, this._settings.metadataSeed, t), this._metadata;
  }
  getIssuer() {
    return this._getMetadataProperty("issuer");
  }
  getAuthorizationEndpoint() {
    return this._getMetadataProperty("authorization_endpoint");
  }
  getUserInfoEndpoint() {
    return this._getMetadataProperty("userinfo_endpoint");
  }
  getTokenEndpoint(e = !0) {
    return this._getMetadataProperty("token_endpoint", e);
  }
  getCheckSessionIframe() {
    return this._getMetadataProperty("check_session_iframe", !0);
  }
  getEndSessionEndpoint() {
    return this._getMetadataProperty("end_session_endpoint", !0);
  }
  getRevocationEndpoint(e = !0) {
    return this._getMetadataProperty("revocation_endpoint", e);
  }
  getKeysEndpoint(e = !0) {
    return this._getMetadataProperty("jwks_uri", e);
  }
  async _getMetadataProperty(e, t = !1) {
    const r = this._logger.create(`_getMetadataProperty('${e}')`), s = await this.getMetadata();
    if (r.debug("resolved"), s[e] === void 0) {
      if (t === !0) {
        r.warn("Metadata does not contain optional property");
        return;
      }
      r.throw(new Error("Metadata does not contain property " + e));
    }
    return s[e];
  }
  async getSigningKeys() {
    const e = this._logger.create("getSigningKeys");
    if (this._signingKeys)
      return e.debug("returning signingKeys from cache"), this._signingKeys;
    const t = await this.getKeysEndpoint(!1);
    e.debug("got jwks_uri", t);
    const r = await this._jsonService.getJson(t);
    if (e.debug("got key set", r), !Array.isArray(r.keys))
      throw e.throw(new Error("Missing keys on keyset")), null;
    return this._signingKeys = r.keys, this._signingKeys;
  }
}, Kt = class {
  constructor({
    prefix: e = "oidc.",
    store: t = localStorage
  } = {}) {
    this._logger = new T("WebStorageStateStore"), this._store = t, this._prefix = e;
  }
  async set(e, t) {
    this._logger.create(`set('${e}')`), e = this._prefix + e, await this._store.setItem(e, t);
  }
  async get(e) {
    return this._logger.create(`get('${e}')`), e = this._prefix + e, await this._store.getItem(e);
  }
  async remove(e) {
    this._logger.create(`remove('${e}')`), e = this._prefix + e;
    const t = await this._store.getItem(e);
    return await this._store.removeItem(e), t;
  }
  async getAllKeys() {
    this._logger.create("getAllKeys");
    const e = await this._store.length, t = [];
    for (let r = 0; r < e; r++) {
      const s = await this._store.key(r);
      s && s.indexOf(this._prefix) === 0 && t.push(s.substr(this._prefix.length));
    }
    return t;
  }
}, Zr = "code", es = "openid", ts = "client_secret_post", rs = "query", ss = 60 * 15, is = 60 * 5, Xe = class {
  constructor({
    // metadata related
    authority: e,
    metadataUrl: t,
    metadata: r,
    signingKeys: s,
    metadataSeed: i,
    // client related
    client_id: o,
    client_secret: a,
    response_type: c = Zr,
    scope: u = es,
    redirect_uri: h,
    post_logout_redirect_uri: w,
    client_authentication: f = ts,
    // optional protocol
    prompt: b,
    display: y,
    max_age: x,
    ui_locales: m,
    acr_values: k,
    resource: O,
    response_mode: l = rs,
    // behavior flags
    filterProtocolClaims: p = !0,
    loadUserInfo: g = !1,
    staleStateAgeInSeconds: _ = ss,
    clockSkewInSeconds: S = is,
    userInfoJwtIssuer: R = "OP",
    mergeClaims: U = !1,
    disablePKCE: j = !1,
    // other behavior
    stateStore: B,
    refreshTokenCredentials: H,
    revokeTokenAdditionalContentTypes: z,
    fetchRequestCredentials: L,
    refreshTokenAllowedScope: $,
    // extra
    extraQueryParams: V = {},
    extraTokenParams: ne = {},
    extraHeaders: te = {}
  }) {
    if (this.authority = e, t ? this.metadataUrl = t : (this.metadataUrl = e, e && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = r, this.metadataSeed = i, this.signingKeys = s, this.client_id = o, this.client_secret = a, this.response_type = c, this.scope = u, this.redirect_uri = h, this.post_logout_redirect_uri = w, this.client_authentication = f, this.prompt = b, this.display = y, this.max_age = x, this.ui_locales = m, this.acr_values = k, this.resource = O, this.response_mode = l, this.filterProtocolClaims = p ?? !0, this.loadUserInfo = !!g, this.staleStateAgeInSeconds = _, this.clockSkewInSeconds = S, this.userInfoJwtIssuer = R, this.mergeClaims = !!U, this.disablePKCE = !!j, this.revokeTokenAdditionalContentTypes = z, L && H && console.warn("Both fetchRequestCredentials and refreshTokenCredentials is set. Only fetchRequestCredentials will be used."), this.fetchRequestCredentials = L || H || "same-origin", B)
      this.stateStore = B;
    else {
      const oe = typeof window < "u" ? window.localStorage : new Jt();
      this.stateStore = new Kt({ store: oe });
    }
    this.refreshTokenAllowedScope = $, this.extraQueryParams = V, this.extraTokenParams = ne, this.extraHeaders = te;
  }
}, ns = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new T("UserInfoService"), this._getClaimsFromJwt = async (r) => {
      const s = this._logger.create("_getClaimsFromJwt");
      try {
        const i = Ye.decode(r);
        return s.debug("JWT decoding successful"), i;
      } catch (i) {
        throw s.error("Error parsing JWT response"), i;
      }
    }, this._jsonService = new at(
      void 0,
      this._getClaimsFromJwt,
      this._settings.extraHeaders
    );
  }
  async getClaims(e) {
    const t = this._logger.create("getClaims");
    e || this._logger.throw(new Error("No token passed"));
    const r = await this._metadataService.getUserInfoEndpoint();
    t.debug("got userinfo url", r);
    const s = await this._jsonService.getJson(r, {
      token: e,
      credentials: this._settings.fetchRequestCredentials
    });
    return t.debug("got claims", s), s;
  }
}, Yt = class {
  constructor(e, t) {
    this._settings = e, this._metadataService = t, this._logger = new T("TokenClient"), this._jsonService = new at(
      this._settings.revokeTokenAdditionalContentTypes,
      null,
      this._settings.extraHeaders
    );
  }
  /**
   * Exchange code.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.1.3
   */
  async exchangeCode({
    grant_type: e = "authorization_code",
    redirect_uri: t = this._settings.redirect_uri,
    client_id: r = this._settings.client_id,
    client_secret: s = this._settings.client_secret,
    ...i
  }) {
    const o = this._logger.create("exchangeCode");
    r || o.throw(new Error("A client_id is required")), t || o.throw(new Error("A redirect_uri is required")), i.code || o.throw(new Error("A code is required"));
    const a = new URLSearchParams({ grant_type: e, redirect_uri: t });
    for (const [w, f] of Object.entries(i))
      f != null && a.set(w, f);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!s)
          throw o.throw(new Error("A client_secret is required")), null;
        c = Y.generateBasicAuth(r, s);
        break;
      case "client_secret_post":
        a.append("client_id", r), s && a.append("client_secret", s);
        break;
    }
    const u = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const h = await this._jsonService.postForm(u, { body: a, basicAuth: c, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), h;
  }
  /**
   * Exchange credentials.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-4.3.2
   */
  async exchangeCredentials({
    grant_type: e = "password",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    scope: s = this._settings.scope,
    ...i
  }) {
    const o = this._logger.create("exchangeCredentials");
    t || o.throw(new Error("A client_id is required"));
    const a = new URLSearchParams({ grant_type: e, scope: s });
    for (const [w, f] of Object.entries(i))
      f != null && a.set(w, f);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw o.throw(new Error("A client_secret is required")), null;
        c = Y.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        a.append("client_id", t), r && a.append("client_secret", r);
        break;
    }
    const u = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const h = await this._jsonService.postForm(u, { body: a, basicAuth: c, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), h;
  }
  /**
   * Exchange a refresh token.
   *
   * @see https://www.rfc-editor.org/rfc/rfc6749#section-6
   */
  async exchangeRefreshToken({
    grant_type: e = "refresh_token",
    client_id: t = this._settings.client_id,
    client_secret: r = this._settings.client_secret,
    timeoutInSeconds: s,
    ...i
  }) {
    const o = this._logger.create("exchangeRefreshToken");
    t || o.throw(new Error("A client_id is required")), i.refresh_token || o.throw(new Error("A refresh_token is required"));
    const a = new URLSearchParams({ grant_type: e });
    for (const [w, f] of Object.entries(i))
      Array.isArray(f) ? f.forEach((b) => a.append(w, b)) : f != null && a.set(w, f);
    let c;
    switch (this._settings.client_authentication) {
      case "client_secret_basic":
        if (!r)
          throw o.throw(new Error("A client_secret is required")), null;
        c = Y.generateBasicAuth(t, r);
        break;
      case "client_secret_post":
        a.append("client_id", t), r && a.append("client_secret", r);
        break;
    }
    const u = await this._metadataService.getTokenEndpoint(!1);
    o.debug("got token endpoint");
    const h = await this._jsonService.postForm(u, { body: a, basicAuth: c, timeoutInSeconds: s, initCredentials: this._settings.fetchRequestCredentials });
    return o.debug("got response"), h;
  }
  /**
   * Revoke an access or refresh token.
   *
   * @see https://datatracker.ietf.org/doc/html/rfc7009#section-2.1
   */
  async revoke(e) {
    var t;
    const r = this._logger.create("revoke");
    e.token || r.throw(new Error("A token is required"));
    const s = await this._metadataService.getRevocationEndpoint(!1);
    r.debug(`got revocation endpoint, revoking ${(t = e.token_type_hint) != null ? t : "default token type"}`);
    const i = new URLSearchParams();
    for (const [o, a] of Object.entries(e))
      a != null && i.set(o, a);
    i.set("client_id", this._settings.client_id), this._settings.client_secret && i.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(s, { body: i }), r.debug("got response");
  }
}, os = class {
  constructor(e, t, r) {
    this._settings = e, this._metadataService = t, this._claimsService = r, this._logger = new T("ResponseValidator"), this._userInfoService = new ns(this._settings, this._metadataService), this._tokenClient = new Yt(this._settings, this._metadataService);
  }
  async validateSigninResponse(e, t) {
    const r = this._logger.create("validateSigninResponse");
    this._processSigninState(e, t), r.debug("state processed"), await this._processCode(e, t), r.debug("code processed"), e.isOpenId && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t == null ? void 0 : t.skipUserInfo, e.isOpenId), r.debug("claims processed");
  }
  async validateCredentialsResponse(e, t) {
    const r = this._logger.create("validateCredentialsResponse");
    e.isOpenId && e.id_token && this._validateIdTokenAttributes(e), r.debug("tokens validated"), await this._processClaims(e, t, e.isOpenId), r.debug("claims processed");
  }
  async validateRefreshResponse(e, t) {
    var r, s;
    const i = this._logger.create("validateRefreshResponse");
    e.userState = t.data, (r = e.session_state) != null || (e.session_state = t.session_state), (s = e.scope) != null || (e.scope = t.scope), e.isOpenId && e.id_token && (this._validateIdTokenAttributes(e, t.id_token), i.debug("ID Token validated")), e.id_token || (e.id_token = t.id_token, e.profile = t.profile);
    const o = e.isOpenId && !!e.id_token;
    await this._processClaims(e, !1, o), i.debug("claims processed");
  }
  validateSignoutResponse(e, t) {
    const r = this._logger.create("validateSignoutResponse");
    if (t.id !== e.state && r.throw(new Error("State does not match")), r.debug("state validated"), e.userState = t.data, e.error)
      throw r.warn("Response was error", e.error), new ie(e);
  }
  _processSigninState(e, t) {
    var r;
    const s = this._logger.create("_processSigninState");
    if (t.id !== e.state && s.throw(new Error("State does not match")), t.client_id || s.throw(new Error("No client_id on state")), t.authority || s.throw(new Error("No authority on state")), this._settings.authority !== t.authority && s.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== t.client_id && s.throw(new Error("client_id mismatch on settings vs. signin state")), s.debug("state validated"), e.userState = t.data, e.url_state = t.url_state, (r = e.scope) != null || (e.scope = t.scope), e.error)
      throw s.warn("Response was error", e.error), new ie(e);
    t.code_verifier && !e.code && s.throw(new Error("Expected code in response"));
  }
  async _processClaims(e, t = !1, r = !0) {
    const s = this._logger.create("_processClaims");
    if (e.profile = this._claimsService.filterProtocolClaims(e.profile), t || !this._settings.loadUserInfo || !e.access_token) {
      s.debug("not loading user info");
      return;
    }
    s.debug("loading user info");
    const i = await this._userInfoService.getClaims(e.access_token);
    s.debug("user info claims received from user info endpoint"), r && i.sub !== e.profile.sub && s.throw(new Error("subject from UserInfo response does not match subject in ID Token")), e.profile = this._claimsService.mergeClaims(e.profile, this._claimsService.filterProtocolClaims(i)), s.debug("user info claims received, updated profile:", e.profile);
  }
  async _processCode(e, t) {
    const r = this._logger.create("_processCode");
    if (e.code) {
      r.debug("Validating code");
      const s = await this._tokenClient.exchangeCode({
        client_id: t.client_id,
        client_secret: t.client_secret,
        code: e.code,
        redirect_uri: t.redirect_uri,
        code_verifier: t.code_verifier,
        ...t.extraTokenParams
      });
      Object.assign(e, s);
    } else
      r.debug("No code to process");
  }
  _validateIdTokenAttributes(e, t) {
    var r;
    const s = this._logger.create("_validateIdTokenAttributes");
    s.debug("decoding ID Token JWT");
    const i = Ye.decode((r = e.id_token) != null ? r : "");
    if (i.sub || s.throw(new Error("ID Token is missing a subject claim")), t) {
      const o = Ye.decode(t);
      i.sub !== o.sub && s.throw(new Error("sub in id_token does not match current sub")), i.auth_time && i.auth_time !== o.auth_time && s.throw(new Error("auth_time in id_token does not match original auth_time")), i.azp && i.azp !== o.azp && s.throw(new Error("azp in id_token does not match original azp")), !i.azp && o.azp && s.throw(new Error("azp not in id_token, but present in original id_token"));
    }
    e.profile = i;
  }
}, le = class {
  constructor(e) {
    this.id = e.id || Y.generateUUIDv4(), this.data = e.data, e.created && e.created > 0 ? this.created = e.created : this.created = D.getEpochTime(), this.request_type = e.request_type, this.url_state = e.url_state;
  }
  toStorageString() {
    return new T("State").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state
    });
  }
  static fromStorageString(e) {
    return T.createStatic("State", "fromStorageString"), new le(JSON.parse(e));
  }
  static async clearStaleState(e, t) {
    const r = T.createStatic("State", "clearStaleState"), s = D.getEpochTime() - t, i = await e.getAllKeys();
    r.debug("got keys", i);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], c = await e.get(a);
      let u = !1;
      if (c)
        try {
          const h = le.fromStorageString(c);
          r.debug("got item from key:", a, h.created), h.created <= s && (u = !0);
        } catch (h) {
          r.error("Error parsing state for key:", a, h), u = !0;
        }
      else
        r.debug("no item in storage for key:", a), u = !0;
      u && (r.debug("removed item for key:", a), e.remove(a));
    }
  }
}, ct = class extends le {
  constructor(e) {
    super(e), e.code_verifier === !0 ? this.code_verifier = Y.generateCodeVerifier() : e.code_verifier && (this.code_verifier = e.code_verifier), this.code_verifier && (this.code_challenge = Y.generateCodeChallenge(this.code_verifier)), this.authority = e.authority, this.client_id = e.client_id, this.redirect_uri = e.redirect_uri, this.scope = e.scope, this.client_secret = e.client_secret, this.extraTokenParams = e.extraTokenParams, this.response_mode = e.response_mode, this.skipUserInfo = e.skipUserInfo;
  }
  toStorageString() {
    return new T("SigninState").create("toStorageString"), JSON.stringify({
      id: this.id,
      data: this.data,
      created: this.created,
      request_type: this.request_type,
      url_state: this.url_state,
      code_verifier: this.code_verifier,
      authority: this.authority,
      client_id: this.client_id,
      redirect_uri: this.redirect_uri,
      scope: this.scope,
      client_secret: this.client_secret,
      extraTokenParams: this.extraTokenParams,
      response_mode: this.response_mode,
      skipUserInfo: this.skipUserInfo
    });
  }
  static fromStorageString(e) {
    T.createStatic("SigninState", "fromStorageString");
    const t = JSON.parse(e);
    return new ct(t);
  }
}, as = class {
  constructor({
    // mandatory
    url: e,
    authority: t,
    client_id: r,
    redirect_uri: s,
    response_type: i,
    scope: o,
    // optional
    state_data: a,
    response_mode: c,
    request_type: u,
    client_secret: h,
    nonce: w,
    url_state: f,
    resource: b,
    skipUserInfo: y,
    extraQueryParams: x,
    extraTokenParams: m,
    disablePKCE: k,
    ...O
  }) {
    if (this._logger = new T("SigninRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    if (!r)
      throw this._logger.error("ctor: No client_id passed"), new Error("client_id");
    if (!s)
      throw this._logger.error("ctor: No redirect_uri passed"), new Error("redirect_uri");
    if (!i)
      throw this._logger.error("ctor: No response_type passed"), new Error("response_type");
    if (!o)
      throw this._logger.error("ctor: No scope passed"), new Error("scope");
    if (!t)
      throw this._logger.error("ctor: No authority passed"), new Error("authority");
    this.state = new ct({
      data: a,
      request_type: u,
      url_state: f,
      code_verifier: !k,
      client_id: r,
      authority: t,
      redirect_uri: s,
      response_mode: c,
      client_secret: h,
      scope: o,
      extraTokenParams: m,
      skipUserInfo: y
    });
    const l = new URL(e);
    l.searchParams.append("client_id", r), l.searchParams.append("redirect_uri", s), l.searchParams.append("response_type", i), l.searchParams.append("scope", o), w && l.searchParams.append("nonce", w);
    let p = this.state.id;
    f && (p = `${p}${Ge}${f}`), l.searchParams.append("state", p), this.state.code_challenge && (l.searchParams.append("code_challenge", this.state.code_challenge), l.searchParams.append("code_challenge_method", "S256")), b && (Array.isArray(b) ? b : [b]).forEach((_) => l.searchParams.append("resource", _));
    for (const [g, _] of Object.entries({ response_mode: c, ...O, ...x }))
      _ != null && l.searchParams.append(g, _.toString());
    this.url = l.href;
  }
}, cs = "openid", De = class {
  constructor(e) {
    if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = e.get("state"), this.session_state = e.get("session_state"), this.state) {
      const t = decodeURIComponent(this.state).split(Ge);
      this.state = t[0], t.length > 1 && (this.url_state = t.slice(1).join(Ge));
    }
    this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri"), this.code = e.get("code");
  }
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - D.getEpochTime();
  }
  set expires_in(e) {
    typeof e == "string" && (e = Number(e)), e !== void 0 && e >= 0 && (this.expires_at = Math.floor(e) + D.getEpochTime());
  }
  get isOpenId() {
    var e;
    return ((e = this.scope) == null ? void 0 : e.split(" ").includes(cs)) || !!this.id_token;
  }
}, us = class {
  constructor({
    url: e,
    state_data: t,
    id_token_hint: r,
    post_logout_redirect_uri: s,
    extraQueryParams: i,
    request_type: o,
    client_id: a
  }) {
    if (this._logger = new T("SignoutRequest"), !e)
      throw this._logger.error("ctor: No url passed"), new Error("url");
    const c = new URL(e);
    r && c.searchParams.append("id_token_hint", r), a && c.searchParams.append("client_id", a), s && (c.searchParams.append("post_logout_redirect_uri", s), t && (this.state = new le({ data: t, request_type: o }), c.searchParams.append("state", this.state.id)));
    for (const [u, h] of Object.entries({ ...i }))
      h != null && c.searchParams.append(u, h.toString());
    this.url = c.href;
  }
}, ls = class {
  constructor(e) {
    this.state = e.get("state"), this.error = e.get("error"), this.error_description = e.get("error_description"), this.error_uri = e.get("error_uri");
  }
}, ds = [
  "nbf",
  "jti",
  "auth_time",
  "nonce",
  "acr",
  "amr",
  "azp",
  "at_hash"
  // https://openid.net/specs/openid-connect-core-1_0.html#CodeIDToken
], hs = ["sub", "iss", "aud", "exp", "iat"], gs = class {
  constructor(e) {
    this._settings = e, this._logger = new T("ClaimsService");
  }
  filterProtocolClaims(e) {
    const t = { ...e };
    if (this._settings.filterProtocolClaims) {
      let r;
      Array.isArray(this._settings.filterProtocolClaims) ? r = this._settings.filterProtocolClaims : r = ds;
      for (const s of r)
        hs.includes(s) || delete t[s];
    }
    return t;
  }
  mergeClaims(e, t) {
    const r = { ...e };
    for (const [s, i] of Object.entries(t))
      for (const o of Array.isArray(i) ? i : [i]) {
        const a = r[s];
        a === void 0 ? r[s] = o : Array.isArray(a) ? a.includes(o) || a.push(o) : r[s] !== o && (typeof o == "object" && this._settings.mergeClaims ? r[s] = this.mergeClaims(a, o) : r[s] = [a, o]);
      }
    return r;
  }
}, fs = class {
  constructor(e, t) {
    this._logger = new T("OidcClient"), this.settings = e instanceof Xe ? e : new Xe(e), this.metadataService = t ?? new Qr(this.settings), this._claimsService = new gs(this.settings), this._validator = new os(this.settings, this.metadataService, this._claimsService), this._tokenClient = new Yt(this.settings, this.metadataService);
  }
  async createSigninRequest({
    state: e,
    request: t,
    request_uri: r,
    request_type: s,
    id_token_hint: i,
    login_hint: o,
    skipUserInfo: a,
    nonce: c,
    url_state: u,
    response_type: h = this.settings.response_type,
    scope: w = this.settings.scope,
    redirect_uri: f = this.settings.redirect_uri,
    prompt: b = this.settings.prompt,
    display: y = this.settings.display,
    max_age: x = this.settings.max_age,
    ui_locales: m = this.settings.ui_locales,
    acr_values: k = this.settings.acr_values,
    resource: O = this.settings.resource,
    response_mode: l = this.settings.response_mode,
    extraQueryParams: p = this.settings.extraQueryParams,
    extraTokenParams: g = this.settings.extraTokenParams
  }) {
    const _ = this._logger.create("createSigninRequest");
    if (h !== "code")
      throw new Error("Only the Authorization Code flow (with PKCE) is supported");
    const S = await this.metadataService.getAuthorizationEndpoint();
    _.debug("Received authorization endpoint", S);
    const R = new as({
      url: S,
      authority: this.settings.authority,
      client_id: this.settings.client_id,
      redirect_uri: f,
      response_type: h,
      scope: w,
      state_data: e,
      url_state: u,
      prompt: b,
      display: y,
      max_age: x,
      ui_locales: m,
      id_token_hint: i,
      login_hint: o,
      acr_values: k,
      resource: O,
      request: t,
      request_uri: r,
      extraQueryParams: p,
      extraTokenParams: g,
      request_type: s,
      response_mode: l,
      client_secret: this.settings.client_secret,
      skipUserInfo: a,
      nonce: c,
      disablePKCE: this.settings.disablePKCE
    });
    await this.clearStaleState();
    const U = R.state;
    return await this.settings.stateStore.set(U.id, U.toStorageString()), R;
  }
  async readSigninResponseState(e, t = !1) {
    const r = this._logger.create("readSigninResponseState"), s = new De(Ve.readParams(e, this.settings.response_mode));
    if (!s.state)
      throw r.throw(new Error("No state in response")), null;
    const i = await this.settings.stateStore[t ? "remove" : "get"](s.state);
    if (!i)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: ct.fromStorageString(i), response: s };
  }
  async processSigninResponse(e) {
    const t = this._logger.create("processSigninResponse"), { state: r, response: s } = await this.readSigninResponseState(e, !0);
    return t.debug("received state from storage; validating response"), await this._validator.validateSigninResponse(s, r), s;
  }
  async processResourceOwnerPasswordCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1,
    extraTokenParams: s = {}
  }) {
    const i = await this._tokenClient.exchangeCredentials({ username: e, password: t, ...s }), o = new De(new URLSearchParams());
    return Object.assign(o, i), await this._validator.validateCredentialsResponse(o, r), o;
  }
  async useRefreshToken({
    state: e,
    timeoutInSeconds: t
  }) {
    var r;
    const s = this._logger.create("useRefreshToken");
    let i;
    if (this.settings.refreshTokenAllowedScope === void 0)
      i = e.scope;
    else {
      const c = this.settings.refreshTokenAllowedScope.split(" ");
      i = (((r = e.scope) == null ? void 0 : r.split(" ")) || []).filter((h) => c.includes(h)).join(" ");
    }
    const o = await this._tokenClient.exchangeRefreshToken({
      refresh_token: e.refresh_token,
      resource: e.resource,
      // provide the (possible filtered) scope list
      scope: i,
      timeoutInSeconds: t
    }), a = new De(new URLSearchParams());
    return Object.assign(a, o), s.debug("validating response", a), await this._validator.validateRefreshResponse(a, {
      ...e,
      // overide the scope in the state handed over to the validator
      // so it can set the granted scope to the requested scope in case none is included in the response
      scope: i
    }), a;
  }
  async createSignoutRequest({
    state: e,
    id_token_hint: t,
    client_id: r,
    request_type: s,
    post_logout_redirect_uri: i = this.settings.post_logout_redirect_uri,
    extraQueryParams: o = this.settings.extraQueryParams
  } = {}) {
    const a = this._logger.create("createSignoutRequest"), c = await this.metadataService.getEndSessionEndpoint();
    if (!c)
      throw a.throw(new Error("No end session endpoint")), null;
    a.debug("Received end session endpoint", c), !r && i && !t && (r = this.settings.client_id);
    const u = new us({
      url: c,
      id_token_hint: t,
      client_id: r,
      post_logout_redirect_uri: i,
      state_data: e,
      extraQueryParams: o,
      request_type: s
    });
    await this.clearStaleState();
    const h = u.state;
    return h && (a.debug("Signout request has state to persist"), await this.settings.stateStore.set(h.id, h.toStorageString())), u;
  }
  async readSignoutResponseState(e, t = !1) {
    const r = this._logger.create("readSignoutResponseState"), s = new ls(Ve.readParams(e, this.settings.response_mode));
    if (!s.state) {
      if (r.debug("No state in response"), s.error)
        throw r.warn("Response was error:", s.error), new ie(s);
      return { state: void 0, response: s };
    }
    const i = await this.settings.stateStore[t ? "remove" : "get"](s.state);
    if (!i)
      throw r.throw(new Error("No matching state found in storage")), null;
    return { state: le.fromStorageString(i), response: s };
  }
  async processSignoutResponse(e) {
    const t = this._logger.create("processSignoutResponse"), { state: r, response: s } = await this.readSignoutResponseState(e, !0);
    return r ? (t.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(s, r)) : t.debug("No state from storage; skipping response validation"), s;
  }
  clearStaleState() {
    return this._logger.create("clearStaleState"), le.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
  }
  async revokeToken(e, t) {
    return this._logger.create("revokeToken"), await this._tokenClient.revoke({
      token: e,
      token_type_hint: t
    });
  }
}, ps = class {
  constructor(e) {
    this._userManager = e, this._logger = new T("SessionMonitor"), this._start = async (t) => {
      const r = t.session_state;
      if (!r)
        return;
      const s = this._logger.create("_start");
      if (t.profile ? (this._sub = t.profile.sub, this._sid = t.profile.sid, s.debug("session_state", r, ", sub", this._sub)) : (this._sub = void 0, this._sid = void 0, s.debug("session_state", r, ", anonymous user")), this._checkSessionIFrame) {
        this._checkSessionIFrame.start(r);
        return;
      }
      try {
        const i = await this._userManager.metadataService.getCheckSessionIframe();
        if (i) {
          s.debug("initializing check session iframe");
          const o = this._userManager.settings.client_id, a = this._userManager.settings.checkSessionIntervalInSeconds, c = this._userManager.settings.stopCheckSessionOnError, u = new Xr(this._callback, o, i, a, c);
          await u.load(), this._checkSessionIFrame = u, u.start(r);
        } else
          s.warn("no check session iframe found in the metadata");
      } catch (i) {
        s.error("Error from getCheckSessionIframe:", i instanceof Error ? i.message : i);
      }
    }, this._stop = () => {
      const t = this._logger.create("_stop");
      if (this._sub = void 0, this._sid = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
        const r = setInterval(async () => {
          clearInterval(r);
          try {
            const s = await this._userManager.querySessionStatus();
            if (s) {
              const i = {
                session_state: s.session_state,
                profile: s.sub && s.sid ? {
                  sub: s.sub,
                  sid: s.sid
                } : null
              };
              this._start(i);
            }
          } catch (s) {
            t.error("error from querySessionStatus", s instanceof Error ? s.message : s);
          }
        }, 1e3);
      }
    }, this._callback = async () => {
      const t = this._logger.create("_callback");
      try {
        const r = await this._userManager.querySessionStatus();
        let s = !0;
        r && this._checkSessionIFrame ? r.sub === this._sub ? (s = !1, this._checkSessionIFrame.start(r.session_state), r.sid === this._sid ? t.debug("same sub still logged in at OP, restarting check session iframe; session_state", r.session_state) : (t.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", r.session_state), this._userManager.events._raiseUserSessionChanged())) : t.debug("different subject signed into OP", r.sub) : t.debug("subject no longer signed into OP"), s ? this._sub ? this._userManager.events._raiseUserSignedOut() : this._userManager.events._raiseUserSignedIn() : t.debug("no change in session detected, no event to raise");
      } catch (r) {
        this._sub && (t.debug("Error calling queryCurrentSigninSession; raising signed out event", r), this._userManager.events._raiseUserSignedOut());
      }
    }, e || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((t) => {
      this._logger.error(t);
    });
  }
  async _init() {
    this._logger.create("_init");
    const e = await this._userManager.getUser();
    if (e)
      this._start(e);
    else if (this._userManager.settings.monitorAnonymousSession) {
      const t = await this._userManager.querySessionStatus();
      if (t) {
        const r = {
          session_state: t.session_state,
          profile: t.sub && t.sid ? {
            sub: t.sub,
            sid: t.sid
          } : null
        };
        this._start(r);
      }
    }
  }
}, ke = class {
  constructor(e) {
    var t;
    this.id_token = e.id_token, this.session_state = (t = e.session_state) != null ? t : null, this.access_token = e.access_token, this.refresh_token = e.refresh_token, this.token_type = e.token_type, this.scope = e.scope, this.profile = e.profile, this.expires_at = e.expires_at, this.state = e.userState, this.url_state = e.url_state;
  }
  /** Computed number of seconds the access token has remaining. */
  get expires_in() {
    if (this.expires_at !== void 0)
      return this.expires_at - D.getEpochTime();
  }
  set expires_in(e) {
    e !== void 0 && (this.expires_at = Math.floor(e) + D.getEpochTime());
  }
  /** Computed value indicating if the access token is expired. */
  get expired() {
    const e = this.expires_in;
    if (e !== void 0)
      return e <= 0;
  }
  /** Array representing the parsed values from the `scope`. */
  get scopes() {
    var e, t;
    return (t = (e = this.scope) == null ? void 0 : e.split(" ")) != null ? t : [];
  }
  toStorageString() {
    return new T("User").create("toStorageString"), JSON.stringify({
      id_token: this.id_token,
      session_state: this.session_state,
      access_token: this.access_token,
      refresh_token: this.refresh_token,
      token_type: this.token_type,
      scope: this.scope,
      profile: this.profile,
      expires_at: this.expires_at
    });
  }
  static fromStorageString(e) {
    return T.createStatic("User", "fromStorageString"), new ke(JSON.parse(e));
  }
}, Mt = "oidc-client", Vt = class {
  constructor() {
    this._abort = new Z("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
  }
  async navigate(e) {
    const t = this._logger.create("navigate");
    if (!this._window)
      throw new Error("Attempted to navigate on a disposed window");
    t.debug("setting URL in window"), this._window.location.replace(e.url);
    const { url: r, keepOpen: s } = await new Promise((i, o) => {
      const a = (c) => {
        var u;
        const h = c.data, w = (u = e.scriptOrigin) != null ? u : window.location.origin;
        if (!(c.origin !== w || (h == null ? void 0 : h.source) !== Mt)) {
          try {
            const f = Ve.readParams(h.url, e.response_mode).get("state");
            if (f || t.warn("no state found in response url"), c.source !== this._window && f !== e.state)
              return;
          } catch {
            this._dispose(), o(new Error("Invalid response from window"));
          }
          i(h);
        }
      };
      window.addEventListener("message", a, !1), this._disposeHandlers.add(() => window.removeEventListener("message", a, !1)), this._disposeHandlers.add(this._abort.addHandler((c) => {
        this._dispose(), o(c);
      }));
    });
    return t.debug("got response from window"), this._dispose(), s || this.close(), { url: r };
  }
  _dispose() {
    this._logger.create("_dispose");
    for (const e of this._disposeHandlers)
      e();
    this._disposeHandlers.clear();
  }
  static _notifyParent(e, t, r = !1, s = window.location.origin) {
    e.postMessage({
      source: Mt,
      url: t,
      keepOpen: r
    }, s);
  }
}, Gt = {
  location: !1,
  toolbar: !1,
  height: 640,
  closePopupWindowAfterInSeconds: -1
}, Xt = "_blank", _s = 60, vs = 2, Qt = 10, ws = class extends Xe {
  constructor(e) {
    const {
      popup_redirect_uri: t = e.redirect_uri,
      popup_post_logout_redirect_uri: r = e.post_logout_redirect_uri,
      popupWindowFeatures: s = Gt,
      popupWindowTarget: i = Xt,
      redirectMethod: o = "assign",
      redirectTarget: a = "self",
      iframeNotifyParentOrigin: c = e.iframeNotifyParentOrigin,
      iframeScriptOrigin: u = e.iframeScriptOrigin,
      silent_redirect_uri: h = e.redirect_uri,
      silentRequestTimeoutInSeconds: w = Qt,
      automaticSilentRenew: f = !0,
      validateSubOnSilentRenew: b = !0,
      includeIdTokenInSilentRenew: y = !1,
      monitorSession: x = !1,
      monitorAnonymousSession: m = !1,
      checkSessionIntervalInSeconds: k = vs,
      query_status_response_type: O = "code",
      stopCheckSessionOnError: l = !0,
      revokeTokenTypes: p = ["access_token", "refresh_token"],
      revokeTokensOnSignout: g = !1,
      includeIdTokenInSilentSignout: _ = !1,
      accessTokenExpiringNotificationTimeInSeconds: S = _s,
      userStore: R
    } = e;
    if (super(e), this.popup_redirect_uri = t, this.popup_post_logout_redirect_uri = r, this.popupWindowFeatures = s, this.popupWindowTarget = i, this.redirectMethod = o, this.redirectTarget = a, this.iframeNotifyParentOrigin = c, this.iframeScriptOrigin = u, this.silent_redirect_uri = h, this.silentRequestTimeoutInSeconds = w, this.automaticSilentRenew = f, this.validateSubOnSilentRenew = b, this.includeIdTokenInSilentRenew = y, this.monitorSession = x, this.monitorAnonymousSession = m, this.checkSessionIntervalInSeconds = k, this.stopCheckSessionOnError = l, this.query_status_response_type = O, this.revokeTokenTypes = p, this.revokeTokensOnSignout = g, this.includeIdTokenInSilentSignout = _, this.accessTokenExpiringNotificationTimeInSeconds = S, R)
      this.userStore = R;
    else {
      const U = typeof window < "u" ? window.sessionStorage : new Jt();
      this.userStore = new Kt({ store: U });
    }
  }
}, Qe = class extends Vt {
  constructor({
    silentRequestTimeoutInSeconds: e = Qt
  }) {
    super(), this._logger = new T("IFrameWindow"), this._timeoutInSeconds = e, this._frame = Qe.createHiddenIframe(), this._window = this._frame.contentWindow;
  }
  static createHiddenIframe() {
    const e = window.document.createElement("iframe");
    return e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-1000px", e.style.top = "0", e.width = "0", e.height = "0", window.document.body.appendChild(e), e;
  }
  async navigate(e) {
    this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
    const t = setTimeout(() => this._abort.raise(new ot("IFrame timed out without a response")), this._timeoutInSeconds * 1e3);
    return this._disposeHandlers.add(() => clearTimeout(t)), await super.navigate(e);
  }
  close() {
    var e;
    this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (t) => {
      var r;
      const s = t.target;
      (r = s.parentNode) == null || r.removeChild(s), this._abort.raise(new Error("IFrame removed from DOM"));
    }, !0), (e = this._frame.contentWindow) == null || e.location.replace("about:blank")), this._frame = null), this._window = null;
  }
  static notifyParent(e, t) {
    return super._notifyParent(window.parent, e, !1, t);
  }
}, ms = class {
  constructor(e) {
    this._settings = e, this._logger = new T("IFrameNavigator");
  }
  async prepare({
    silentRequestTimeoutInSeconds: e = this._settings.silentRequestTimeoutInSeconds
  }) {
    return new Qe({ silentRequestTimeoutInSeconds: e });
  }
  async callback(e) {
    this._logger.create("callback"), Qe.notifyParent(e, this._settings.iframeNotifyParentOrigin);
  }
}, ys = 500, Ss = 1e3, qt = class extends Vt {
  constructor({
    popupWindowTarget: e = Xt,
    popupWindowFeatures: t = {}
  }) {
    super(), this._logger = new T("PopupWindow");
    const r = jt.center({ ...Gt, ...t });
    this._window = window.open(void 0, e, jt.serialize(r)), t.closePopupWindowAfterInSeconds && t.closePopupWindowAfterInSeconds > 0 && setTimeout(() => {
      if (!this._window || typeof this._window.closed != "boolean" || this._window.closed) {
        this._abort.raise(new Error("Popup blocked by user"));
        return;
      }
      this.close();
    }, t.closePopupWindowAfterInSeconds * Ss);
  }
  async navigate(e) {
    var t;
    (t = this._window) == null || t.focus();
    const r = setInterval(() => {
      (!this._window || this._window.closed) && this._abort.raise(new Error("Popup closed by user"));
    }, ys);
    return this._disposeHandlers.add(() => clearInterval(r)), await super.navigate(e);
  }
  close() {
    this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
  }
  static notifyOpener(e, t) {
    if (!window.opener)
      throw new Error("No window.opener. Can't complete notification.");
    return super._notifyParent(window.opener, e, t);
  }
}, bs = class {
  constructor(e) {
    this._settings = e, this._logger = new T("PopupNavigator");
  }
  async prepare({
    popupWindowFeatures: e = this._settings.popupWindowFeatures,
    popupWindowTarget: t = this._settings.popupWindowTarget
  }) {
    return new qt({ popupWindowFeatures: e, popupWindowTarget: t });
  }
  async callback(e, { keepOpen: t = !1 }) {
    this._logger.create("callback"), qt.notifyOpener(e, t);
  }
}, ks = class {
  constructor(e) {
    this._settings = e, this._logger = new T("RedirectNavigator");
  }
  async prepare({
    redirectMethod: e = this._settings.redirectMethod,
    redirectTarget: t = this._settings.redirectTarget
  }) {
    var r;
    this._logger.create("prepare");
    let s = window.self;
    t === "top" && (s = (r = window.top) != null ? r : window.self);
    const i = s.location[e].bind(s.location);
    let o;
    return {
      navigate: async (a) => {
        this._logger.create("navigate");
        const c = new Promise((u, h) => {
          o = h;
        });
        return i(a.url), await c;
      },
      close: () => {
        this._logger.create("close"), o == null || o(new Error("Redirect aborted")), s.stop();
      }
    };
  }
  async callback() {
  }
}, Es = class extends Gr {
  constructor(e) {
    super({ expiringNotificationTimeInSeconds: e.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new T("UserManagerEvents"), this._userLoaded = new Z("User loaded"), this._userUnloaded = new Z("User unloaded"), this._silentRenewError = new Z("Silent renew error"), this._userSignedIn = new Z("User signed in"), this._userSignedOut = new Z("User signed out"), this._userSessionChanged = new Z("User session changed");
  }
  load(e, t = !0) {
    super.load(e), t && this._userLoaded.raise(e);
  }
  unload() {
    super.unload(), this._userUnloaded.raise();
  }
  /**
   * Add callback: Raised when a user session has been established (or re-established).
   */
  addUserLoaded(e) {
    return this._userLoaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been established (or re-established).
   */
  removeUserLoaded(e) {
    return this._userLoaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when a user session has been terminated.
   */
  addUserUnloaded(e) {
    return this._userUnloaded.addHandler(e);
  }
  /**
   * Remove callback: Raised when a user session has been terminated.
   */
  removeUserUnloaded(e) {
    return this._userUnloaded.removeHandler(e);
  }
  /**
   * Add callback: Raised when the automatic silent renew has failed.
   */
  addSilentRenewError(e) {
    return this._silentRenewError.addHandler(e);
  }
  /**
   * Remove callback: Raised when the automatic silent renew has failed.
   */
  removeSilentRenewError(e) {
    return this._silentRenewError.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseSilentRenewError(e) {
    this._silentRenewError.raise(e);
  }
  /**
   * Add callback: Raised when the user is signed in (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedIn(e) {
    return this._userSignedIn.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user is signed in (when `monitorSession` is set).
   */
  removeUserSignedIn(e) {
    this._userSignedIn.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedIn() {
    this._userSignedIn.raise();
  }
  /**
   * Add callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSignedOut(e) {
    return this._userSignedOut.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user's sign-in status at the OP has changed (when `monitorSession` is set).
   */
  removeUserSignedOut(e) {
    this._userSignedOut.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSignedOut() {
    this._userSignedOut.raise();
  }
  /**
   * Add callback: Raised when the user session changed (when `monitorSession` is set).
   * @see {@link UserManagerSettings.monitorSession}
   */
  addUserSessionChanged(e) {
    return this._userSessionChanged.addHandler(e);
  }
  /**
   * Remove callback: Raised when the user session changed (when `monitorSession` is set).
   */
  removeUserSessionChanged(e) {
    this._userSessionChanged.removeHandler(e);
  }
  /**
   * @internal
   */
  _raiseUserSessionChanged() {
    this._userSessionChanged.raise();
  }
}, Rs = class {
  constructor(e) {
    this._userManager = e, this._logger = new T("SilentRenewService"), this._isStarted = !1, this._retryTimer = new D("Retry Silent Renew"), this._tokenExpiring = async () => {
      const t = this._logger.create("_tokenExpiring");
      try {
        await this._userManager.signinSilent(), t.debug("silent token renewal successful");
      } catch (r) {
        if (r instanceof ot) {
          t.warn("ErrorTimeout from signinSilent:", r, "retry in 5s"), this._retryTimer.init(5);
          return;
        }
        t.error("Error from signinSilent:", r), this._userManager.events._raiseSilentRenewError(r);
      }
    };
  }
  async start() {
    const e = this._logger.create("start");
    if (!this._isStarted) {
      this._isStarted = !0, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
      try {
        await this._userManager.getUser();
      } catch (t) {
        e.error("getUser error", t);
      }
    }
  }
  stop() {
    this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = !1);
  }
}, Ts = class {
  constructor(e, t) {
    this.refresh_token = e.refresh_token, this.id_token = e.id_token, this.session_state = e.session_state, this.scope = e.scope, this.profile = e.profile, this.resource = t, this.data = e.state;
  }
}, xs = class {
  constructor(e, t, r, s) {
    this._logger = new T("UserManager"), this.settings = new ws(e), this._client = new fs(e), this._redirectNavigator = t ?? new ks(this.settings), this._popupNavigator = r ?? new bs(this.settings), this._iframeNavigator = s ?? new ms(this.settings), this._events = new Es(this.settings), this._silentRenewService = new Rs(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new ps(this));
  }
  /** Returns an object used to register for events raised by the `UserManager`. */
  get events() {
    return this._events;
  }
  /** Returns an object used to access the metadata configuration of the OIDC provider. */
  get metadataService() {
    return this._client.metadataService;
  }
  /**
   * Returns promise to load the `User` object for the currently authenticated user.
   */
  async getUser() {
    const e = this._logger.create("getUser"), t = await this._loadUser();
    return t ? (e.info("user loaded"), this._events.load(t, !1), t) : (e.info("user not found in storage"), null);
  }
  /**
   * Returns promise to remove from any storage the currently authenticated user.
   */
  async removeUser() {
    const e = this._logger.create("removeUser");
    await this.storeUser(null), e.info("user removed from storage"), this._events.unload();
  }
  /**
   * Returns promise to trigger a redirect of the current window to the authorization endpoint.
   */
  async signinRedirect(e = {}) {
    this._logger.create("signinRedirect");
    const {
      redirectMethod: t,
      ...r
    } = e, s = await this._redirectNavigator.prepare({ redirectMethod: t });
    await this._signinStart({
      request_type: "si:r",
      ...r
    }, s);
  }
  /**
   * Returns promise to process response from the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signinRedirectCallback"), r = await this._signinEnd(e);
    return r.profile && r.profile.sub ? t.info("success, signed in subject", r.profile.sub) : t.info("no subject"), r;
  }
  /**
   * Returns promise to process the signin with user/password. The result of the promise is the authenticated `User`.
   *
   * Throws an ErrorResponse in case of wrong authentication.
   */
  async signinResourceOwnerCredentials({
    username: e,
    password: t,
    skipUserInfo: r = !1
  }) {
    const s = this._logger.create("signinResourceOwnerCredential"), i = await this._client.processResourceOwnerPasswordCredentials({ username: e, password: t, skipUserInfo: r, extraTokenParams: this.settings.extraTokenParams });
    s.debug("got signin response");
    const o = await this._buildUser(i);
    return o.profile && o.profile.sub ? s.info("success, signed in subject", o.profile.sub) : s.info("no subject"), o;
  }
  /**
   * Returns promise to trigger a request (via a popup window) to the authorization endpoint. The result of the promise is the authenticated `User`.
   */
  async signinPopup(e = {}) {
    const t = this._logger.create("signinPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: s,
      ...i
    } = e, o = this.settings.popup_redirect_uri;
    o || t.throw(new Error("No popup_redirect_uri configured"));
    const a = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: s }), c = await this._signin({
      request_type: "si:p",
      redirect_uri: o,
      display: "popup",
      ...i
    }, a);
    return c && (c.profile && c.profile.sub ? t.info("success, signed in subject", c.profile.sub) : t.info("no subject")), c;
  }
  /**
   * Returns promise to notify the opening window of response from the authorization endpoint.
   */
  async signinPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signinPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), r.info("success");
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the authorization endpoint.
   * The result of the promise is the authenticated `User`.
   */
  async signinSilent(e = {}) {
    var t;
    const r = this._logger.create("signinSilent"), {
      silentRequestTimeoutInSeconds: s,
      resource: i,
      ...o
    } = e;
    let a = await this._loadUser();
    if (a != null && a.refresh_token) {
      r.debug("using refresh token");
      const w = new Ts(a, i);
      return await this._useRefreshToken(w);
    }
    const c = this.settings.silent_redirect_uri;
    c || r.throw(new Error("No silent_redirect_uri configured"));
    let u;
    a && this.settings.validateSubOnSilentRenew && (r.debug("subject prior to silent renew:", a.profile.sub), u = a.profile.sub);
    const h = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s });
    return a = await this._signin({
      request_type: "si:s",
      redirect_uri: c,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? a == null ? void 0 : a.id_token : void 0,
      ...o
    }, h, u), a && ((t = a.profile) != null && t.sub ? r.info("success, signed in subject", a.profile.sub) : r.info("no subject")), a;
  }
  async _useRefreshToken(e) {
    const t = await this._client.useRefreshToken({
      state: e,
      timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds
    }), r = new ke({ ...e, ...t });
    return await this.storeUser(r), this._events.load(r), r;
  }
  /**
   * Returns promise to notify the parent window of response from the authorization endpoint.
   */
  async signinSilentCallback(e = window.location.href) {
    const t = this._logger.create("signinSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async signinCallback(e = window.location.href) {
    const { state: t } = await this._client.readSigninResponseState(e);
    switch (t.request_type) {
      case "si:r":
        return await this.signinRedirectCallback(e);
      case "si:p":
        return await this.signinPopupCallback(e);
      case "si:s":
        return await this.signinSilentCallback(e);
      default:
        throw new Error("invalid response_type in state");
    }
  }
  async signoutCallback(e = window.location.href, t = !1) {
    const { state: r } = await this._client.readSignoutResponseState(e);
    if (r)
      switch (r.request_type) {
        case "so:r":
          await this.signoutRedirectCallback(e);
          break;
        case "so:p":
          await this.signoutPopupCallback(e, t);
          break;
        case "so:s":
          await this.signoutSilentCallback(e);
          break;
        default:
          throw new Error("invalid response_type in state");
      }
  }
  /**
   * Returns promise to query OP for user's current signin status. Returns object with session_state and subject identifier.
   */
  async querySessionStatus(e = {}) {
    const t = this._logger.create("querySessionStatus"), {
      silentRequestTimeoutInSeconds: r,
      ...s
    } = e, i = this.settings.silent_redirect_uri;
    i || t.throw(new Error("No silent_redirect_uri configured"));
    const o = await this._loadUser(), a = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r }), c = await this._signinStart({
      request_type: "si:s",
      // this acts like a signin silent
      redirect_uri: i,
      prompt: "none",
      id_token_hint: this.settings.includeIdTokenInSilentRenew ? o == null ? void 0 : o.id_token : void 0,
      response_type: this.settings.query_status_response_type,
      scope: "openid",
      skipUserInfo: !0,
      ...s
    }, a);
    try {
      const u = await this._client.processSigninResponse(c.url);
      return t.debug("got signin response"), u.session_state && u.profile.sub ? (t.info("success for subject", u.profile.sub), {
        session_state: u.session_state,
        sub: u.profile.sub,
        sid: u.profile.sid
      }) : (t.info("success, user not authenticated"), null);
    } catch (u) {
      if (this.settings.monitorAnonymousSession && u instanceof ie)
        switch (u.error) {
          case "login_required":
          case "consent_required":
          case "interaction_required":
          case "account_selection_required":
            return t.info("success for anonymous user"), {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              session_state: u.session_state
            };
        }
      throw u;
    }
  }
  async _signin(e, t, r) {
    const s = await this._signinStart(e, t);
    return await this._signinEnd(s.url, r);
  }
  async _signinStart(e, t) {
    const r = this._logger.create("_signinStart");
    try {
      const s = await this._client.createSigninRequest(e);
      return r.debug("got signin request"), await t.navigate({
        url: s.url,
        state: s.state.id,
        response_mode: s.state.response_mode,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (s) {
      throw r.debug("error after preparing navigator, closing navigator window"), t.close(), s;
    }
  }
  async _signinEnd(e, t) {
    const r = this._logger.create("_signinEnd"), s = await this._client.processSigninResponse(e);
    return r.debug("got signin response"), await this._buildUser(s, t);
  }
  async _buildUser(e, t) {
    const r = this._logger.create("_buildUser"), s = new ke(e);
    if (t) {
      if (t !== s.profile.sub)
        throw r.debug("current user does not match user returned from signin. sub from signin:", s.profile.sub), new ie({ ...e, error: "login_required" });
      r.debug("current user matches user returned from signin");
    }
    return await this.storeUser(s), r.debug("user stored"), this._events.load(s), s;
  }
  /**
   * Returns promise to trigger a redirect of the current window to the end session endpoint.
   */
  async signoutRedirect(e = {}) {
    const t = this._logger.create("signoutRedirect"), {
      redirectMethod: r,
      ...s
    } = e, i = await this._redirectNavigator.prepare({ redirectMethod: r });
    await this._signoutStart({
      request_type: "so:r",
      post_logout_redirect_uri: this.settings.post_logout_redirect_uri,
      ...s
    }, i), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint.
   */
  async signoutRedirectCallback(e = window.location.href) {
    const t = this._logger.create("signoutRedirectCallback"), r = await this._signoutEnd(e);
    return t.info("success"), r;
  }
  /**
   * Returns promise to trigger a redirect of a popup window window to the end session endpoint.
   */
  async signoutPopup(e = {}) {
    const t = this._logger.create("signoutPopup"), {
      popupWindowFeatures: r,
      popupWindowTarget: s,
      ...i
    } = e, o = this.settings.popup_post_logout_redirect_uri, a = await this._popupNavigator.prepare({ popupWindowFeatures: r, popupWindowTarget: s });
    await this._signout({
      request_type: "so:p",
      post_logout_redirect_uri: o,
      // we're putting a dummy entry in here because we
      // need a unique id from the state for notification
      // to the parent window, which is necessary if we
      // plan to return back to the client after signout
      // and so we can close the popup after signout
      state: o == null ? void 0 : {},
      ...i
    }, a), t.info("success");
  }
  /**
   * Returns promise to process response from the end session endpoint from a popup window.
   */
  async signoutPopupCallback(e = window.location.href, t = !1) {
    const r = this._logger.create("signoutPopupCallback");
    await this._popupNavigator.callback(e, { keepOpen: t }), r.info("success");
  }
  async _signout(e, t) {
    const r = await this._signoutStart(e, t);
    return await this._signoutEnd(r.url);
  }
  async _signoutStart(e = {}, t) {
    var r;
    const s = this._logger.create("_signoutStart");
    try {
      const i = await this._loadUser();
      s.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(i);
      const o = e.id_token_hint || i && i.id_token;
      o && (s.debug("setting id_token_hint in signout request"), e.id_token_hint = o), await this.removeUser(), s.debug("user removed, creating signout request");
      const a = await this._client.createSignoutRequest(e);
      return s.debug("got signout request"), await t.navigate({
        url: a.url,
        state: (r = a.state) == null ? void 0 : r.id,
        scriptOrigin: this.settings.iframeScriptOrigin
      });
    } catch (i) {
      throw s.debug("error after preparing navigator, closing navigator window"), t.close(), i;
    }
  }
  async _signoutEnd(e) {
    const t = this._logger.create("_signoutEnd"), r = await this._client.processSignoutResponse(e);
    return t.debug("got signout response"), r;
  }
  /**
   * Returns promise to trigger a silent request (via an iframe) to the end session endpoint.
   */
  async signoutSilent(e = {}) {
    var t;
    const r = this._logger.create("signoutSilent"), {
      silentRequestTimeoutInSeconds: s,
      ...i
    } = e, o = this.settings.includeIdTokenInSilentSignout ? (t = await this._loadUser()) == null ? void 0 : t.id_token : void 0, a = this.settings.popup_post_logout_redirect_uri, c = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s });
    await this._signout({
      request_type: "so:s",
      post_logout_redirect_uri: a,
      id_token_hint: o,
      ...i
    }, c), r.info("success");
  }
  /**
   * Returns promise to notify the parent window of response from the end session endpoint.
   */
  async signoutSilentCallback(e = window.location.href) {
    const t = this._logger.create("signoutSilentCallback");
    await this._iframeNavigator.callback(e), t.info("success");
  }
  async revokeTokens(e) {
    const t = await this._loadUser();
    await this._revokeInternal(t, e);
  }
  async _revokeInternal(e, t = this.settings.revokeTokenTypes) {
    const r = this._logger.create("_revokeInternal");
    if (!e)
      return;
    const s = t.filter((i) => typeof e[i] == "string");
    if (!s.length) {
      r.debug("no need to revoke due to no token(s)");
      return;
    }
    for (const i of s)
      await this._client.revokeToken(
        e[i],
        // eslint-disable-line @typescript-eslint/no-non-null-assertion
        i
      ), r.info(`${i} revoked successfully`), i !== "access_token" && (e[i] = null);
    await this.storeUser(e), r.debug("user stored"), this._events.load(e);
  }
  /**
   * Enables silent renew for the `UserManager`.
   */
  startSilentRenew() {
    this._logger.create("startSilentRenew"), this._silentRenewService.start();
  }
  /**
   * Disables silent renew for the `UserManager`.
   */
  stopSilentRenew() {
    this._silentRenewService.stop();
  }
  get _userStoreKey() {
    return `user:${this.settings.authority}:${this.settings.client_id}`;
  }
  async _loadUser() {
    const e = this._logger.create("_loadUser"), t = await this.settings.userStore.get(this._userStoreKey);
    return t ? (e.debug("user storageString loaded"), ke.fromStorageString(t)) : (e.debug("no user storageString"), null);
  }
  async storeUser(e) {
    const t = this._logger.create("storeUser");
    if (e) {
      t.debug("storing user");
      const r = e.toStorageString();
      await this.settings.userStore.set(this._userStoreKey, r);
    } else
      this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey);
  }
  /**
   * Removes stale state entries in storage for incomplete authorize requests.
   */
  async clearStaleState() {
    await this._client.clearStaleState();
  }
};
function Cs(e) {
  const { axios: t } = e, r = ee(e);
  r.current = e, se(() => {
    const { onUnauthenticated: s = () => {
    }, onUnauthorized: i = () => {
    }, getAccessToken: o } = r.current;
    if (t == null)
      return;
    const a = (w) => {
      var f, b;
      return ((b = (f = r.current).requireAuth) == null ? void 0 : b.call(f, w)) || !1;
    }, c = t.interceptors, u = c.request.use(Is(a, o)), h = c.response.use(
      (w) => w,
      Os(a, s, i)
    );
    return () => {
      c.request.eject(u), c.response.eject(h);
    };
  }, [t]);
}
function Is(e, t) {
  return (r) => {
    if (!e(r))
      return r;
    const s = t();
    return s != null && r.headers != null && (r.headers["X-FARO-AUTH"] = s), r;
  };
}
function Os(e, t, r) {
  return (s) => {
    var i;
    if (e(s.config)) {
      const o = (i = s.response) == null ? void 0 : i.status;
      if (o === 401)
        return t(s);
      if (o === 403)
        return r(s);
    }
    return Promise.reject(s);
  };
}
function Ps(e) {
  const { userManager: t } = e, r = ee(e);
  r.current = e;
  const s = As(), i = ee({
    licenses: 1
  });
  return se(() => {
    if (i.current.licenses > 0)
      i.current.licenses -= 1;
    else
      return;
    function o(c) {
      var u, h;
      if (c.message.includes("No matching state found in storage"))
        (h = (u = r.current).onNoMatchingStateInStorageError) == null || h.call(u, c);
      else
        throw c;
    }
    (async () => {
      var b, y, x, m;
      const { userManager: c, onBeforeSignIn: u, onSignIn: h, location: w = window.location } = r.current;
      if (Us(w)) {
        const k = await c.signinCallback().catch(o);
        (y = (b = r.current).onUserChange) == null || y.call(b, k), h == null || h(k);
        return;
      }
      const f = await c.getUser();
      if (!f || f.expired) {
        const k = u == null ? void 0 : u();
        c.signinRedirect({ state: k }).catch(o);
      } else
        (m = (x = r.current).onUserChange) == null || m.call(x, f);
    })();
  }, []), se(() => {
    async function o() {
      var c, u;
      const a = await t.getUser();
      s.current && ((u = (c = r.current).onUserChange) == null || u.call(c, a));
    }
    return t.events.addUserLoaded(o), () => t.events.removeUserLoaded(o);
  }, [t]), null;
}
function Us(e) {
  const t = new URLSearchParams(e.search), r = new URLSearchParams(e.hash.replace("#", "?"));
  return !!(t.get("code") || t.get("id_token") || t.get("session_state") || r.get("code") || r.get("id_token") || r.get("session_state"));
}
function As() {
  const e = ee(!0);
  return se(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function js(e) {
  return e.userManager == null ? null : /* @__PURE__ */ pe.jsx(Ps, { ...e, userManager: e.userManager });
}
var Ze = function(e, t) {
  return Ze = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, s) {
    r.__proto__ = s;
  } || function(r, s) {
    for (var i in s)
      Object.prototype.hasOwnProperty.call(s, i) && (r[i] = s[i]);
  }, Ze(e, t);
};
function Ue(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ze(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
function et(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], s = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && s >= e.length && (e = void 0), { value: e && e[s++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Ce(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var s = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = s.next()).done; )
      o.push(i.value);
  } catch (c) {
    a = { error: c };
  } finally {
    try {
      i && !i.done && (r = s.return) && r.call(s);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function Ie(e, t, r) {
  if (r || arguments.length === 2)
    for (var s = 0, i = t.length, o; s < i; s++)
      (o || !(s in t)) && (o || (o = Array.prototype.slice.call(t, 0, s)), o[s] = t[s]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function X(e) {
  return typeof e == "function";
}
function Zt(e) {
  var t = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, r = e(t);
  return r.prototype = Object.create(Error.prototype), r.prototype.constructor = r, r;
}
var Be = Zt(function(e) {
  return function(r) {
    e(this), this.message = r ? r.length + ` errors occurred during unsubscription:
` + r.map(function(s, i) {
      return i + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = r;
  };
});
function tt(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var Ae = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, r, s, i, o;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var c = et(a), u = c.next(); !u.done; u = c.next()) {
              var h = u.value;
              h.remove(this);
            }
          } catch (m) {
            t = { error: m };
          } finally {
            try {
              u && !u.done && (r = c.return) && r.call(c);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          a.remove(this);
      var w = this.initialTeardown;
      if (X(w))
        try {
          w();
        } catch (m) {
          o = m instanceof Be ? m.errors : [m];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var b = et(f), y = b.next(); !y.done; y = b.next()) {
            var x = y.value;
            try {
              Lt(x);
            } catch (m) {
              o = o ?? [], m instanceof Be ? o = Ie(Ie([], Ce(o)), Ce(m.errors)) : o.push(m);
            }
          }
        } catch (m) {
          s = { error: m };
        } finally {
          try {
            y && !y.done && (i = b.return) && i.call(b);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      if (o)
        throw new Be(o);
    }
  }, e.prototype.add = function(t) {
    var r;
    if (t && t !== this)
      if (this.closed)
        Lt(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (r = this._finalizers) !== null && r !== void 0 ? r : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var r = this._parentage;
    return r === t || Array.isArray(r) && r.includes(t);
  }, e.prototype._addParent = function(t) {
    var r = this._parentage;
    this._parentage = Array.isArray(r) ? (r.push(t), r) : r ? [r, t] : t;
  }, e.prototype._removeParent = function(t) {
    var r = this._parentage;
    r === t ? this._parentage = null : Array.isArray(r) && tt(r, t);
  }, e.prototype.remove = function(t) {
    var r = this._finalizers;
    r && tt(r, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), er = Ae.EMPTY;
function tr(e) {
  return e instanceof Ae || e && "closed" in e && X(e.remove) && X(e.add) && X(e.unsubscribe);
}
function Lt(e) {
  X(e) ? e() : e.unsubscribe();
}
var rr = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, rt = {
  setTimeout: function(e, t) {
    for (var r = [], s = 2; s < arguments.length; s++)
      r[s - 2] = arguments[s];
    var i = rt.delegate;
    return i != null && i.setTimeout ? i.setTimeout.apply(i, Ie([e, t], Ce(r))) : setTimeout.apply(void 0, Ie([e, t], Ce(r)));
  },
  clearTimeout: function(e) {
    var t = rt.delegate;
    return ((t == null ? void 0 : t.clearTimeout) || clearTimeout)(e);
  },
  delegate: void 0
};
function Ms(e) {
  rt.setTimeout(function() {
    throw e;
  });
}
function Nt() {
}
function Ee(e) {
  e();
}
var sr = function(e) {
  Ue(t, e);
  function t(r) {
    var s = e.call(this) || this;
    return s.isStopped = !1, r ? (s.destination = r, tr(r) && r.add(s)) : s.destination = Hs, s;
  }
  return t.create = function(r, s, i) {
    return new st(r, s, i);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Ae), qs = Function.prototype.bind;
function $e(e, t) {
  return qs.call(e, t);
}
var Ls = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (s) {
        be(s);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (s) {
        be(s);
      }
    else
      be(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        be(r);
      }
  }, e;
}(), st = function(e) {
  Ue(t, e);
  function t(r, s, i) {
    var o = e.call(this) || this, a;
    if (X(r) || !r)
      a = {
        next: r ?? void 0,
        error: s ?? void 0,
        complete: i ?? void 0
      };
    else {
      var c;
      o && rr.useDeprecatedNextContext ? (c = Object.create(r), c.unsubscribe = function() {
        return o.unsubscribe();
      }, a = {
        next: r.next && $e(r.next, c),
        error: r.error && $e(r.error, c),
        complete: r.complete && $e(r.complete, c)
      }) : a = r;
    }
    return o.destination = new Ls(a), o;
  }
  return t;
}(sr);
function be(e) {
  Ms(e);
}
function Ns(e) {
  throw e;
}
var Hs = {
  closed: !0,
  next: Nt,
  error: Ns,
  complete: Nt
}, Fs = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Ws(e) {
  return e;
}
function Ds(e) {
  return e.length === 0 ? Ws : e.length === 1 ? e[0] : function(r) {
    return e.reduce(function(s, i) {
      return i(s);
    }, r);
  };
}
var Ht = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, s) {
    var i = this, o = $s(t) ? t : new st(t, r, s);
    return Ee(function() {
      var a = i, c = a.operator, u = a.source;
      o.add(c ? c.call(o, u) : u ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var s = this;
    return r = Ft(r), new r(function(i, o) {
      var a = new st({
        next: function(c) {
          try {
            t(c);
          } catch (u) {
            o(u), a.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      s.subscribe(a);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[Fs] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return Ds(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return t = Ft(t), new t(function(s, i) {
      var o;
      r.subscribe(function(a) {
        return o = a;
      }, function(a) {
        return i(a);
      }, function() {
        return s(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Ft(e) {
  var t;
  return (t = e ?? rr.Promise) !== null && t !== void 0 ? t : Promise;
}
function Bs(e) {
  return e && X(e.next) && X(e.error) && X(e.complete);
}
function $s(e) {
  return e && e instanceof sr || Bs(e) && tr(e);
}
var zs = Zt(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ir = function(e) {
  Ue(t, e);
  function t() {
    var r = e.call(this) || this;
    return r.closed = !1, r.currentObservers = null, r.observers = [], r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return t.prototype.lift = function(r) {
    var s = new Wt(this, this);
    return s.operator = r, s;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new zs();
  }, t.prototype.next = function(r) {
    var s = this;
    Ee(function() {
      var i, o;
      if (s._throwIfClosed(), !s.isStopped) {
        s.currentObservers || (s.currentObservers = Array.from(s.observers));
        try {
          for (var a = et(s.currentObservers), c = a.next(); !c.done; c = a.next()) {
            var u = c.value;
            u.next(r);
          }
        } catch (h) {
          i = { error: h };
        } finally {
          try {
            c && !c.done && (o = a.return) && o.call(a);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(r) {
    var s = this;
    Ee(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.hasError = s.isStopped = !0, s.thrownError = r;
        for (var i = s.observers; i.length; )
          i.shift().error(r);
      }
    });
  }, t.prototype.complete = function() {
    var r = this;
    Ee(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.isStopped = !0;
        for (var s = r.observers; s.length; )
          s.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var r;
      return ((r = this.observers) === null || r === void 0 ? void 0 : r.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(r) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, r);
  }, t.prototype._subscribe = function(r) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(r), this._innerSubscribe(r);
  }, t.prototype._innerSubscribe = function(r) {
    var s = this, i = this, o = i.hasError, a = i.isStopped, c = i.observers;
    return o || a ? er : (this.currentObservers = null, c.push(r), new Ae(function() {
      s.currentObservers = null, tt(c, r);
    }));
  }, t.prototype._checkFinalizedStatuses = function(r) {
    var s = this, i = s.hasError, o = s.thrownError, a = s.isStopped;
    i ? r.error(o) : a && r.complete();
  }, t.prototype.asObservable = function() {
    var r = new Ht();
    return r.source = this, r;
  }, t.create = function(r, s) {
    return new Wt(r, s);
  }, t;
}(Ht), Wt = function(e) {
  Ue(t, e);
  function t(r, s) {
    var i = e.call(this) || this;
    return i.destination = r, i.source = s, i;
  }
  return t.prototype.next = function(r) {
    var s, i;
    (i = (s = this.destination) === null || s === void 0 ? void 0 : s.next) === null || i === void 0 || i.call(s, r);
  }, t.prototype.error = function(r) {
    var s, i;
    (i = (s = this.destination) === null || s === void 0 ? void 0 : s.error) === null || i === void 0 || i.call(s, r);
  }, t.prototype.complete = function() {
    var r, s;
    (s = (r = this.destination) === null || r === void 0 ? void 0 : r.complete) === null || s === void 0 || s.call(r);
  }, t.prototype._subscribe = function(r) {
    var s, i;
    return (i = (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(r)) !== null && i !== void 0 ? i : er;
  }, t;
}(ir);
const Js = () => {
  let e;
  self.addEventListener("message", (t) => {
    t.data === "start" ? e = setInterval(() => {
      self.postMessage("tick");
    }, 1e3) : t.data === "stop" && e && clearTimeout(e);
  });
};
var Ks = /* @__PURE__ */ ((e) => (e.Unknown = "Unknown", e.LoggingIn = "LoggingIn", e.LoggedIn = "LoggedIn", e.LoggingOut = "LoggingOut", e.LoggedOut = "LoggedOut", e))(Ks || {});
const _e = nt.createContext(void 0), fe = class fe {
  constructor() {
    Q(this, "timeout", 0);
    Q(this, "warning", 0);
    Q(this, "callback");
    Q(this, "ticking", !1);
    Q(this, "worker", new Worker(URL.createObjectURL(new Blob([`(${Js.toString()})()`]))));
    Q(this, "startedAt", 0);
    window.addEventListener("keydown", this), window.addEventListener("mousemove", this), window.addEventListener("mousedown", this), window.addEventListener("scroll", this), window.addEventListener("touchmove", this), window.addEventListener("pointermove", this), this.worker.addEventListener("message", this);
  }
  /**
   * Accessor for the only object instance of that class
   */
  static getInstance() {
    return fe.instance;
  }
  /**
   * Detects if the session timeout counter is started
   */
  get isTicking() {
    return this.ticking;
  }
  /**
   * Starts the session timeout counter.
   *
   * @param timeout - the period of time (in seconds) after which the @callback will be called with a Timeout notification type.
   * @param warning - the period of time (in seconds) after which the @callback will be called with a Warning notification type.
   * @param callback - a function, which implements the handling of the session timeout notification.
   *  If it was risen with a Timeout notification type - the consumer have to implement the Session Timeout
   *  If it was risen with a Warning notification type - the consumer have to implement the appearance of the Timeout Warning dialog
   *    Currently we are not configuring and not handing the Warning notification type
   */
  start(t, r, s) {
    this.isTicking ? console.warn("The session timeout object has already been started!") : (this.timeout = Math.floor(Math.abs(t < 1 ? 1 : t)), this.warning = r, this.warning > 0 && (this.timeout = Math.floor(Math.abs(r)), this.warning > this.timeout && (this.warning = 0)), this.callback = s, this.startedAt = this.now(), this.worker.postMessage("start"), this.ticking = !0);
  }
  /**
   * Stops the session timeout counter.
   *
   */
  stop() {
    this.ticking && (this.worker.postMessage("stop"), this.ticking = !1, this.startedAt = 0);
  }
  handleEvent(t) {
    var r, s;
    if (t instanceof MessageEvent) {
      if (t.data === "tick") {
        const i = this.now() - this.startedAt;
        i >= this.warning && this.warning > 0 && ((r = this.callback) == null || r.call(this, "Warning")), i >= this.timeout && ((s = this.callback) == null || s.call(this, "Timeout"), this.stop());
      }
    } else
      this.startedAt = this.now() - 1;
  }
  now() {
    return Math.floor(Date.now() / 1e3);
  }
};
Q(fe, "instance", new fe());
let it = fe;
const W = new ir();
function ti(e) {
  const t = ee(e);
  t.current = e;
  const [r, s] = Ct(), i = ee(r);
  i.current = r;
  const o = ee(null), a = ee(), c = typeof e.user != "function" ? e.user : void 0, [u, h] = Ct({
    user: c,
    isLoggingIn: !1,
    isLoggingOut: !1
  }), w = it.getInstance(), f = () => {
    const g = i.current;
    g && (g.removeUser(), g.stopSilentRenew()), s(void 0), h({}), sessionStorage.clear(), o.current = null;
  };
  u.user && ze(e.sessionTimeout).then((g) => {
    g && !w.isTicking && w.start(g, 0, (_) => {
      var S, R;
      _ === "Timeout" && (W.next(
        "LoggingOut"
        /* LoggingOut */
      ), f(), (R = (S = t.current).onSessionTimeout) == null || R.call(S), W.next(
        "LoggedOut"
        /* LoggedOut */
      ));
    });
  }), Cs({
    // The axios instance to configure (defaults to the global axios instance)
    axios: e.axios,
    // Keep Axios up-to-date with the latest access token
    getAccessToken: () => {
      var g;
      return (g = o.current) == null ? void 0 : g.access_token;
    },
    // Only add auth-header to requests matching this
    // Only check for 401 and 403 responses for requests matching this
    requireAuth: e.requireAuth,
    onUnauthenticated: (g) => {
      var _, S;
      h((R) => ({ ...R, error: g })), W.next(
        "LoggingOut"
        /* LoggingOut */
      ), f(), (S = (_ = t.current).onUnauthenticated) == null || S.call(_, g), W.next(
        "LoggedOut"
        /* LoggedOut */
      );
    },
    onUnauthorized: (g) => {
      var _, S;
      return h((R) => ({ ...R, error: g })), (S = (_ = t.current).onUnauthorized) == null ? void 0 : S.call(_, g);
    }
  }), se(() => {
    async function g(_) {
      var S, R;
      h((U) => ({ ...U, error: _ })), Xs(_) && (W.next(
        "LoggingOut"
        /* LoggingOut */
      ), f(), (R = (S = t.current).onSessionTimeout) == null || R.call(S, _), W.next(
        "LoggedOut"
        /* LoggedOut */
      ));
    }
    return r == null || r.events.addSilentRenewError(g), () => {
      r == null || r.events.removeSilentRenewError(g);
    };
  }, [r]);
  const b = ue(async () => {
    h((g) => ({
      ...g,
      isLoggingIn: !0
    })), W.next(
      "LoggingIn"
      /* LoggingIn */
    );
    try {
      const g = await ze(t.current.options), _ = Gs(g);
      s(_), W.next(
        "LoggedIn"
        /* LoggedIn */
      );
    } catch (g) {
      h((_) => ({
        ..._,
        isLoggingIn: !1,
        error: g
      })), W.next(
        "Unknown"
        /* Unknown */
      );
    }
  }, []), y = ue(async () => {
    var g, _;
    h((S) => ({ ...S, isLoggingOut: !0 })), W.next(
      "LoggingOut"
      /* LoggingOut */
    ), sessionStorage.clear(), await ((_ = i.current) == null ? void 0 : _.signoutRedirect({
      post_logout_redirect_uri: (g = t.current) == null ? void 0 : g.postLogoutRedirectUrl
    })), h((S) => ({ ...S, isLoggingOut: !1 })), W.next(
      "LoggedOut"
      /* LoggedOut */
    );
  }, []), x = ue(() => {
    var g;
    return (g = o.current) == null ? void 0 : g.access_token;
  }, []), m = It(() => {
    async function g() {
      h((S) => ({
        ...S,
        isLoading: !0
      }));
      try {
        const S = await ze(t.current.user);
        h({
          user: S,
          isLoggingIn: !1,
          isLoggingOut: !1
        });
      } catch (S) {
        h((R) => ({
          ...R,
          isLoggingIn: !1,
          isLoggingOut: !1,
          error: S
        }));
      }
    }
    async function _(S) {
      if (o.current = S, S == null)
        return;
      const R = S.profile.email;
      (a.current == null || a.current !== R) && (a.current = R, await g());
    }
    return _;
  }, []), k = ue(() => {
    var g, _;
    (_ = (g = t.current).onBeforeSignIn) == null || _.call(g);
  }, []), O = ue(() => {
    var g, _;
    (_ = (g = t.current).onSignIn) == null || _.call(g);
  }, []), l = ue((g) => {
    var _;
    (_ = e.onNoMatchingStateInStorageError) == null || _.call(e, g);
  }, []), p = It(() => ({ state: u, login: b, logout: y, events: W, getAccessToken: x }), [u]);
  return /* @__PURE__ */ pe.jsxs(_e.Provider, { value: p, children: [
    /* @__PURE__ */ pe.jsx(
      js,
      {
        userManager: r,
        onBeforeSignIn: k,
        onSignIn: O,
        onUserChange: m,
        onNoMatchingStateInStorageError: l
      }
    ),
    e.children
  ] });
}
function Ys() {
  if (Re(_e) == null)
    throw new Error("useAuth must be used within the FaroAuthContext.");
  return Re(_e);
}
function ri() {
  const e = Re(_e);
  if (e == null)
    throw new Error("useUser must be used within the FaroAuthContext.");
  return e.state.user;
}
function Vs() {
  const e = Re(_e);
  if (e == null)
    throw new Error("useAutoLogin must be used within the FaroAuthContext.");
  const {
    state: { user: t, isLoggingIn: r },
    login: s
  } = e;
  return se(() => {
    t == null && !r && s();
  }, [t, r]), e;
}
function ze(e) {
  return Promise.resolve(typeof e == "function" ? e() : e);
}
function Gs(e) {
  const { authority: t, clientId: r, redirectUri: s, scope: i, metadataUrl: o } = e;
  return new xs({
    authority: t,
    metadataUrl: o,
    client_id: r,
    redirect_uri: s,
    scope: i,
    loadUserInfo: !1,
    automaticSilentRenew: !0,
    response_type: "code"
  });
}
function Xs(e) {
  return "error" in e && e.error != null;
}
function si(e) {
  const { children: t, loading: r = null, errorHandler: s = null } = e, {
    state: { user: i, error: o }
  } = Vs();
  return i == null ? r : o != null && s != null ? s(o, "Login failed") : t;
}
function ii(e) {
  var h;
  const { children: t, granted: r, useAppPermissions: s, errorHandler: i = null } = e, o = Ur(), {
    state: { error: a }
  } = Ys(), c = s(), u = a && ((h = a.response) == null ? void 0 : h.status) === 403 || r != null && !(r != null && r(c));
  return se(() => {
    u && o("/unauthorized");
  }, [u]), u ? /* @__PURE__ */ pe.jsx(pe.Fragment, {}) : a != null && i != null ? i(a, "Login failed") : t;
}
export {
  si as AuthenticatedRoute,
  Ks as AuthenticationState,
  ii as AuthorizedRoute,
  _e as FaroAuthContext,
  ti as FaroAuthProvider,
  Ys as useAuth,
  Vs as useAutoLogin,
  ri as useUser
};
//# sourceMappingURL=index.mjs.map
